export default {
	demo_account:{
        footerpoint1:`Fxview is the trading name of the Fxview group of companies which consists of:`,
        footerpoint2:`- Parent company, Finvasia Securities Private Ltd, regulated by the Securities and Exchange Board of India (Licence No INZ000176037)`,
        footerpoint3:`- Charlgate Ltd, regulated by the Cyprus Securities and Exchange Commission (Licence No 367/18)`,
        footerpoint4:`- Charlgate SVG LLC (Reg. No. 1112 LLC 2021) with registered address at First Floor, First St Vincent Bank Ltd Building, James Street, Kingstown, Saint Vincent and the Grenadines.`,
        footerpoint5:`- Nevea Services Ltd (Reg. No. 422664) with registered address at 319, 28th October Street, Kanika Business Center, Office 201B, Limassol 3105, Cyprus.`,
        footerpoint6:`The merchant company is Nevea Services Ltd with registered address at 319, 28th October Street, Kanika Business Center, Office 201B, Limassol 3105, Cyprus. The merchant company provides content, administrative services, payment processing and safekeeping services.`,
        footerpoint7:`Clients must be at least 18 years old to use the services of Fxview.`,
        footerpoint8:`Trading complex instruments on margin carries a high level of risk and may not be suitable for all investors. Before deciding to trade, you should carefully consider your trading objectives, level of experience and risk appetite. It is possible for you to sustain losses that exceed your invested capital, and therefore you should not deposit money that you cannot afford to lose. Please ensure you fully understand the risks and take appropriate care to manage them.`,
        footerpoint9:`This site contains links to websites controlled or offered by third parties. Fxview has not reviewed and hereby disclaims responsibility for any information or materials posted at any of the sites linked to this site. By creating a link to a thirdparty website, Fxview does not endorse or recommend any products or services offered on that website. The information contained on this site is intended for informational purposes only. Therefore, it should not be regarded as an offer or solicitation to any person in any jurisdiction in which such an offer or solicitation is not authorized or to any person to whom it would be unlawful to make such an offer or solicitation, nor regarded as recommendation to buy, sell or otherwise deal with any particular trade. If you are not sure about your local trading regulations, then you should leave this site immediately.`,
        footerpoint10:`You are strongly advised to obtain independent financial, legal and tax advice before proceeding with any trade. Nothing on this site should be read or construed as constituting advice on the part of Fxview or any of its affiliates, directors, officers or employees.`,
        footerpoint11:`The services of Fxview and the information on this site are not directed at residents of the Crimea, Cuba, Cyprus, India, Iran, North Korea, Sudan, Syria, and the United States and are not intended for distribution to, or use by, any person in any country or jurisdiction where such distribution or use would be contrary to local law or regulation.`,
        high_risk_warning:'High Risk Warning',
        open_a:'Open a',
        free_demo:'Free Demo',
        account_on:'Account',
        mt4:'MetaTrader 4',
        mt5:'MetaTrader 5',
        act:'ActTrader',
        or:'or',
        register:'Register',
        login:'Login',
        have_acc:'Have an account?',
        'register_form_otp_msg':'One-Time Pin has been sent to your email. Please enter it below.',
        'register_form_open_an_account':'Open an Account',
        'register_form_will_take_minut':'It will take less than a minute',
        'register_form_select_residence_country':'Select Residence Country',
        'register_form_email':'Email Address',
        'register_form_pass':'Enter Password',
        'register_form_cpass':'Confirm Password',
        'register_form_privacy_agree':'By Signing up you agree to our',
        'register_form_privacy_policy':'Privacy Policy',
        website_use:'Website Use',
        cookies_policy:'Cookies Policy',
	    refund_policy:'Refund Policy',
	    AML_policy:'AML Policy',
        'sub_heading1_our':'Our',
        'sub_heading1_features':'Features',
        'sub_heading1_title':`Unleash your trading potential and conquer the market with our unbeatable trading conditions.`,
        'sub_heading1_sub_container1_in_depth':'In-depth',
        'sub_heading1_sub_container1_learning':'Learning',
        'sub_heading1_sub_container1_description':'Enhance your trading by signing up to our free webinars and learn from experts. Our webinars are specifically designed to boost your market knowledge and hone your trading skills.',
        'sub_heading1_sub_container2_risk_free':`Risk-free`,
        'sub_heading1_sub_container2_trading':'Trading',
        'sub_heading1_sub_container2_description':`Whether you're new to trading or already an experienced forex trader, discover your trading prowess at Fxview, with our risk-free forex demo account.`,
        'sub_heading1_sub_container3_hundreds_of':'Hundreds of',
        'sub_heading1_sub_container3_tradable_instruments':'tradable instruments',
        'sub_heading1_sub_container3_description':'Gain access to over 500 trading products ranging from Fx to Commodities, Stocks, Indices, and digital assets.',
        'sub_heading1_sub_container4_real_prices_with':'Real prices with',
        'sub_heading1_sub_container4_fast_execution':'fast execution',
        'sub_heading1_sub_container4_description':'Experience real-time trading, explore a plethora of tools and strategies, and sharpen your skills all while trading in a completely risk-free demo account.',
        'sub_heading2_frequently_asked':'Frequently Asked',
        'sub_heading2_questions':'Questions',
        'sub_heading2_description':`Get Your Questions Answered: Your Ultimate Guide.`,
        'sub_heading2_more_info':'More Info',
        'sub_heading2_faq1_question':`Is there a time limit to using a demo account?`,
        'sub_heading2_faq1_answer':`You can use the demo account for as long as you wish. The account only gets deactivated if there is no activity for 30 consecutive days.`,
        'sub_heading2_faq2_question':`Can I open multiple demo accounts with different trading platforms?`,
        'sub_heading2_faq2_answer':`Yes, you can. There is no limit on the number of demo accounts one can open with different platforms.`,
        'sub_heading2_faq3_question':`What’s the difference between a demo and live trading account?`,
        'sub_heading2_faq3_answer':`Live trading accounts need to be funded with real money for placing trades. Whereas demo accounts are funded with virtual money to eliminate the risk of losing real money. Other than this the trading conditions, tools, and features are almost the same for both demo and live accounts.`,
        'sub_heading2_faq4_question':`What’s the maximum amount I can trade in a demo account?`,
        'sub_heading2_faq4_answer':`You will get $100,000 to trade in the demo account. This amount gets refilled once the balance goes nil.`,
        'sub_heading2_faq5_question':`Can I practice CFD trading in a demo account?`,
        'sub_heading2_faq5_answer':`Yes, you are free to trade any instrument that we offer for live trading on your demo account.`,
        'sub_heading2_faq6_question':`Can I open multiple demo accounts?`,
        'sub_heading2_faq6_answer':`Yes, you can open multiple demo accounts with different platforms. But only one demo account can be opened for each type of account.`,
        'sub_heading2_faq7_question':`Is there an inactivity fee on demo account?`,
        'sub_heading2_faq7_answer':`No, we don’t charge any inactivity fee, but the demo account will be deactivated if not used for 30 consecutive days.`,
    },
	financial_details: 'Financial Details',
	reg_step_one_point: 'If employed please specify',
	reg_step_one_point_two: 'Estimated Annual Income (USD)',
	reg_step_one_point_three: 'Estimated Net Worth (USD)',
	reg_step_one_point_four: 'Source Of Funds',
	accountancy: 'Accountancy',
	admin_secretarial: 'Admin/Secretarial',
	auctions: 'Auctions',
	catering_hospitality: 'Catering/Hospitality',
	creative_media: 'Creative/Media ',
	education: 'Education',
	emergency_services: 'Emergency Services',
	engineering: 'Engineering',
	financial_services: 'Financial Services',
	gas_petrol: 'Gas/Petrol',
	health_medicine: 'Health/Medicine',
	army_industry: 'Army/Army Industry',
	hr: 'HR',
	insurance: 'Insurance ',
	legal: 'Legal',
	leisure_tourism: 'Leisure/Tourism ',
	manufacturing: 'Manufacturing ',
	marketing_pr_advertising: 'Marketing/PR/Advertising',
	pharmaceuticals: 'Pharmaceuticals ',
	precious_metals_Diamonds: 'Precious metals/Diamonds',
	property_construction_real_state: 'Property Construction/Real Estate ',
	retail: 'Retail',
	sales: 'Sales',
	social_care_services: 'Social Care/Services ',
	telecommunications: 'Telecommunications',
	transport_logistics: 'Transport/Logistics ',
	trust_charities_foundations: 'Trust/Charities/Foundations ',
	virtual_currency: 'Virtual Currency',
	other_please_specify: 'Other (Please specify)',
	till_ten_thousand: '0-10,000',
	till_fifty_thousand: '10,000-50,000',
	till_one_lac:'50,000-100,000',
	till_two_lac: '100,000-200,000' ,
	above_two_lac:'Above 200,000',
	zero_fiftythousand: '0-50,000',
	till_fiftythousand: '50,000-100,000',
	till_three_lac: '100,000-300,000',
	above_three_lac: '300,000+',
	employment: 'Employment',
	inheritance: 'Inheritance',
	investment: 'Investment',
	real_estate: 'Real Estate' ,
	savings: 'Savings',
	other: 'Other',
	reg_step_three: `Let's test your trading experience`,
	reg_step_three_point: 'As a regulated entity, we are required to assess whether you have appropriate understanding to trade leveraged products. Please complete your Appropriateness test carefully, as your responses will be used to determine whether you can open a Live trading account with us.',
	start_test: 'Start Test',

	
	depMsz1: 'Processing Time:',
	depMsz2: '1 to 5 working days',
	depMsz3: 'Fee:',
	depMsz4: '0',
	depMsz10: 'Instant 24/7',
	MiniDepositAmount: "Minimum Deposit Amount",
	DntSkill: "you don't have any skrill id , please",
	depMsz12: 'to change your Skrill ID',
	netId: "Netteller Id :",
	depMsz13: 'Not the right Neteller account? Please',
	depMsz14: 'To change your Neteller ID',
	Clickhere: "Click HERE.",
	DntNetteler: "you don't have any netteller id , please",
	Tocreate: "to create.",
	conPay: 'Confirm Deposit',
	depMsz15: 'Please ensure that the deposit details are correct. If you are happy with everything, click the ‘Fund Now’ button to proceed. Please note that if you make a withdrawal after depositing into your account, your funds will most likely be returned to the same method used to deposit.',financial_details: 'Financial Details',
	accountId: "Account ID",
	feeUsd: 'Fee (USD)',
	depositAmount: 'Deposit Amount',
	paymentMethod: 'Deposit Method',
	backToStep: 'Previous step',
	procToPay: 'Proceed To Payment',
	personalInfo: 'Personal Information',
	fname: 'First Name',
	lname: 'Last Name',
	InvalidNumber: "Invalid Phone Number",
	saveContinue: 'Save & Continue',
	termsAgreeRqd: "Please agree terms in order to proceed",
	googleOtp: "Please enter the one time passcode shown in the <strong>Google Authenticator</strong> app.",
	enterAmount: 'Enter Amount',
	allowDeposit1lac: 'we are not allowing deposit more then 1,00,000 for demo account',
	SearchSomething: "Search Here",
	search: "Search",
	Prev: "Prev",
	Next: "Next",


	PleaseEnsureCorrect: "Please ensure that details are correct",

	//====================users====================================
	//============login page
	lg_riskWarningMsg: 'CFDs are complex instruments and come with a high risk of losing money rapidly due to leverage. The vast majority of retail client accounts lose money when trading in CFDs. You should consider whether you understand how CFDs work and whether you can afford to take the high risk of losing your money.',
	lg_welcomeMsgHeadone: 'Competitive Trading Conditions',
	lg_welcomeMsg1: 'Benefit from spreads as low as 0.0 pips on major fx pairs, and commission of $1 per $100,000 per side.',
	lg_welcomeMsgHeadtwo: 'Our Platforms',
	lg_welcomeMsg2: "Access the world's most popular markets on our fast and reliable platforms - MT4, MT5 & ActTrader",
	lg_welcomeMsgHeadthree: 'Trading Tools',
	lg_welcomeMsg3: "Access a wide range of trading tools such as Autochartist, Trader’s Tool Box, API trading and more",
	lg_signin: 'Log in to Fxview',
	lg_emailaddress: 'Email Address',
	lg_EmailfieldValid: 'Please enter a valid email address',
	lg_EmailfieldReq: 'The Email field is required',
	lg_password: 'Password',
	lg_logIn: 'Sign In',
	lg_forgotPassword: 'Forgot Password',
	lg_donthaveaccount: 'Don’t have an account?',
	lg_signuphere: 'Sign up here',
	lg_charlgateMsGlobal: 'Finvasia Capital South Africa (PTY) Ltd company registered in South Africa with Company Number 2018/303451/07. The Registered Office Address is 3rd Floor, 34 Whiteley Blvd, Melrose Arch, Birnam, 2196.',
	lg_charlgateMsEurope: 'Charlgate Ltd is authorised and regulated by CySEC, with licence number 367/18 & company registration number 372060.',
	lg_varify2step: 'Two-step Verification',
	lg_EnterAuthCode: 'Enter Authentication Code',
	lg_submit: 'Submit',
	lg_backLogin: 'Back to login',
	lg_footerMsz2: 'Your capital is at risk. You may lose all the capital invested.',
	lg_riskDisclaimer: 'Risk Disclaimer',

	//============forgot password
	fp_forgotPasswordText: 'Please enter your registered email address with fxview so we can help you create a new password.',
	fp_resetPassword: 'Reset Password',
	fp_RESEND_EMAIL: 'Resend Email',
	fp_backLogin: 'Back to log in page',
	fp_charlgateMsg: 'Charlgate Ltd owns fxview.com.  Charlgate Ltd is a company authorised and regulated by the Cyprus Securities and Exchange Commission – CySEC (CySEC Licence number 367/18 & company registration number : 372060 ) and a Member of the Investor Compensation Fund (ICF).',

	//=============register
	reg_welcomemsg1: '<h3>Spreads</h3><p>from 0.0 pip</p>',
	reg_welcomemsg2: '<h3>$1 per</h3><p>$100K Commission</p>',
	reg_welcomemsg3: '<h3>A Variety of</h3><p>Trading Tools</p>',
	reg_welcomemsg4: '<h3>Ultra</h3><p>Fast Execution</p>',
	reg_welcomemsg5: '<h3>100%</h3><p>Deposit Bonus',
	reg_openacc: 'Open An Account',
	reg_takeminute: 'It will take less than a minute',
	reg_selectacctype: 'select account type',
	reg_selectcountry: 'select residence country',
	reg_Enterfname: 'Enter First Name',
	reg_Entername: 'Enter Your Name',
	reg_Enterlname: 'Enter Last Name',
	reg_Enteremail: 'Enter Email Address',
	reg_Enterpwd: 'Enter Password',
	reg_passwordFieldReq: 'The password field is required',
	reg_passCharVal: 'Your password must contain at least 6 characters, and include at least 1 number, 1 uppercase character and 1 special character (!@#$%^*)',
	reg_conPassword: 'Confirm Password',
	reg_ConfpasswordReq: 'The confirm password field is required.',
	reg_newConfFieldSame: 'The entered passwords do not match. Please try again',
	reg_captchaErr: 'Invalid Captcha',
	reg_register: 'Register',
	reg_signagree: 'By signing up you agree to our',
	reg_privacyPolicy: ' Privacy Policy',
	reg_haveAccount: 'Have an account?',
	reg_login: 'Log in',
	reg_registerMsz2: 'One-Time Pin has been sent to your email. Please enter it below.',
	reg_enterOtp: 'Enter OTP',
	reg_submit: 'Submit',
	reg_resendotp: 'Resend OTP',

	//==========reset password from hash
	rp_passwordHashMsz2: 'Password has been changed successfully. Click',
	rp_here: 'Here',
	rp_toLogin: 'to log in',
	rp_otherWayHelp: 'Other ways to get help',
	rp_chatWithUs: 'Chat with us',
	rp_or: 'or',
	rp_callUs: 'Call us',

	//=============profile 
	prof_verified: 'Verified',
	prof_undrreview: 'Your application is under review!',
	prof_checkstatus: 'Please check the status of your ticket',
	prof_clickhere: 'Click Here',
	prof_completeRegister: 'Complete Registration',
	prof_basicDetail: 'Basic Info',
	prof_addressDetail: 'Address Info',
	prof_paymentDetail: 'Payment Details',
	prof_documents: 'Documents',
	prof_fname: 'First Name',
	prof_lname: 'Last Name',
	prof_DOB: 'Date of birth',
	prof_phone: 'Phone',
	prof_Member: 'Member',
	prof_companyname: 'Company Name',
	prof_incorporationdate: 'Incorporation date',
	prof_currency: 'Currency',
	prof_emailaddress: 'Email Address',
	prof_PEP: 'Politically Exposed Person (PEP)',
	prof_addressLine1: 'Residential Address line 1',
	prof_addressLine2: 'Residential Address line 2',
	prof_postCode: 'Post Code',
	prof_city: 'City or Town',
	prof_resCountry: 'Country of Residence',
	prof_bankName: 'Bank Name:',
	prof_AccNumber: 'Account Number:',
	prof_Pending: 'Pending',
	prof_Disable: 'Disable',
	prof_viewDetail: 'view detail',
	prof_paymentMethod: 'Deposit Method',
	prof_AccountName: 'Account Name',
	prof_SwiftCode: 'Swift/BIC/Sort Code',
	prof_IBAN: 'IBAN',
	prof_bankAdd: 'Bank Address:',
	prof_onlinePayId: 'Online Payment ID:',
	prof_Change: 'Change',
	prof_CreditCard: 'Credit Card Number:',
	prof_ExpiryDate: 'Expiry Date:',
	prof_noBankDetail: 'No Bank Details',
	prof_AddBank: 'Add Bank',
	prof_AddCard: 'Add Credit card',
	prof_noDocuments: 'No Documents',
	prof_disablecard: 'kindly disable my credit card payment method, information as given below :',
	prof_creditcardno: 'credit card number : **** **** ****',
	prof_bankpaymentmethod: 'kindly disable my bank transfer payment method, information as given below :',
	prof_diablepaymentmethod: 'Disable Payment Method',
	prof_addpeymentmethod: 'Add Payment Method',

	//=================2fa 
	twoFA_faText: 'Two-Factor Authentication',
	twoFA_alreadyEnabled: 'Enabled',
	twoFA_setUp2FA: 'Set up 2FA',
	twoFA_clickToDisable: 'Click To Disable',
	twoFA_clickToEnable: 'Click To Enable',
	twoFA_enable2FaText: 'Enable Two-Factor Authentication',
	twoFA_accounntSafe3Steps: 'Make Your Account safer in 3 easy steps:',
	twoFA_downloaduthApp: 'Download an Authenticator App',
	twoFA_downloaduthAppText: 'Download and install Authy or Google Authenticator to your phone or tablet.',
	twoFA_scanQrCode: 'Scan The QR Code',
	twoFA_scanQrCodeText: "Open the authentication app and scan the image to the left, using your phone's camera.",
	twoFA_loginYourCode: 'Log in with your Code',
	twoFA_enter6DigitCode: 'Enter the 6-digit verification code generated.',
	twoFA_activate: 'Activate',
	twoFA_enterOtpDisableQrCode: 'Please Enter OTP to Disable QR Code',
	twoFA_disableCodeText: 'Disable With your Code',
	//===========change password
	cp_changePassword: 'Change Password',
	cp_oldpwd: 'Old Password',
	cp_newPassword: 'New Password',
	cp_conPassword: 'Confirm password',
	cp_passCharval: 'Your password must contain at least 6 characters, maximum 15 characters and include at least 1 number, 1 uppercase character and 1 special character (!@#$%^*)',

	//========welcome
	welcm_fewStepAway: 'You are just few steps away',
	welcm_activateFxviewAccountNow: 'Activate Your Fxview Account Now!',
	welcm_setupFxViewAcc: 'Setup your fxview account',
	welcm_modify: 'Modify',
	welcm_addFund: 'Add Funds',
	welcm_startTrading: 'Start Trading',
	welcm_welcomeFxView: 'Welcome to Fxview!',
	welcm_welFxviewCon: 'You are almost ready to begin trading. Please complete your trading account application and upload the necessary identification documents.',
	welcm_completeReg: 'Complete Registration',
	welcm_tryDemoAcc: 'Try a Demo Account',
	welcm_tryDemoAccCon: 'Try our trading platforms - MT4, MT5 and ActTrader - and develop your CFD trading skills. Practice trading with virtual funds',
	welcm_createDemoAccount: 'Demo Account',
	welcm_downloadPlatform: 'Download Platform',
	welcm_MT4: 'Meta Trader 4',
	welcm_winIosAndroid: 'Windows/IOS/Android',
	welcm_MT5: 'Meta Trader 5',
	welcm_actTrader: 'ActTrader<sup>TM</sup>',
	welcm_rangeTradTools: 'Range of Trading Tools',
	welcm_wlcmMsz1: 'Identify automatically generated trade ideas based on chart patterns, breakouts, trend reversals, Fibonacci patterns and technical indicators.',
	welcm_wlcmMsz2: 'Explore a wide range of actionable trade ideas recognised on the basis of multiple chart patterns and technical indicators across various assets class.',
	welcm_wlcmMsz3: 'Stay a step ahead with real time financial news and updates on geo-political events to make informed trading decisions.',
	welcm_wlcmMsz4: 'Stay up to date with real time Economic calendar that encompasses key global economic events and indicators on the horizon.',
	welcm_wlcmMsz5: 'Get an unmatched trading experience via suitable VPS hosting program that allows you to trade uninterruptedly with reduced latency.',
	welcm_SeeMore: 'See More',

	//========user notification
	notif_Notification: 'Notification',
	notif_noNewNotification: 'No New Notifications',

	//=========request-verify
	verf_reqProcessing: 'request processing...',
	verf_reqVerify: 'Request Verification',
	verf_dear: 'Dear ',
	verf_requestVerifyWith: 'Your withdrawal request has been processed successfully',
	verf_backWithList: 'Back To Withdrawals List',
	verf_reqFailed: 'Request Failed',
	verf_msg: 'Your withdrawal request has been failed',
	//============refer a friend 
	refer_Refera: 'Refer a ',
	refer_friend: 'Friend',
	refer_opportunity: 'Our refer a friend program gives you an opportunity to earn $20 for every friend  you refer. What’s more, your friend will also be rewarded $20 when they sign up with your invitation email.',
	refer_Refernow: 'Refer Now',
	refer_howorks: 'How it Works',
	refer_everyclient: 'For every client you refer, we will reward you with $20. Share your favourite things about fxview with your friends and enjoy additional trading margin, on us.',
	refer_stepmsg1: 'Register or log in to your fxview account',
	refer_stepmsg2: 'Invite your friend using the form in the client area',
	refer_stepmsg3: 'Your friend will receive an email invite and will follow the steps to register',
	refer_stepmsg4: 'Both you and your friend will receive $20 once you and your friend funds their account with $200 or more',
	refer_referEmail: 'Referred Email',
	refer_addmore: 'Add more',
	refer_nowrefer: 'refer now',
	refer_successRefer: 'You have Successfully Referred',
	refer_refrMore: 'Refer More',
	refer_godashboard: 'Go to Dashboard',
	refer_partnerprog: 'Our other partnership program',
	refer_Affilialte: 'Affiliate Program',
	refer_uniquelink: 'Get your unique referral link',
	refer_trackearn: 'Track your earnings from referrals',
	refer_monitorStatus: 'Monitor the status of your referrals',
	refer_withdrawearn: 'Withdraw your earnings as you wish',
	refer_register: 'Register',
	refer_knowmore: 'Know More',
	refer_brokerprogram: 'Introducing Broker Program',
	refer_uniqueIB: 'Unique IB portal',
	refer_IBmanager: 'Dedicated IB manager',
	refer_controlearn: 'Take control of your earnings',
	refer_regislink: 'unique IB registration link',
	refer_clientlist: 'Client List',
	refer_email: 'Email',
	refer_accountStatus: 'Account Stage',
	refer_volumereq: 'Volume requirement',
	refer_tradedvol: 'Traded Volume',
	refer_qualified: 'Qualified',
	refer_action: 'Action',
	refer_successDelete: 'You have Successfully Deleted',
	refer_fromReflist: 'from your Referrel list',
	refer_wantTodelete: 'Do you want to delete',
	refer_confrm: 'Confirm',
	refer_enterEmailrefer: 'Please Enter Email to refer',
	refer_error: 'error',
	refer_errorReferal: 'You must be verified and funded before referral.',

	//===========dashboard
	dash_overview: 'Overview',
	dash_traderRoom: "Trader's Room",
	dash_personalInfo: 'Personal Information',
	dash_declaration: 'Declaration',
	dash_uploadDocumen: 'Upload Personal Documents',
	dash_completeReg: 'Complete Registration',
	dash_checkticketstatus: 'Please check the status of your ticket.',
	dash_clickhere: 'Click Here',
	dash_TradingAcc: 'Trading Accounts',
	dash_live: 'Live',
	dash_demo: 'Demo',
	dash_Platform: 'Platform',
	dash_tradAccId: 'Account ID',
	dash_Leverage: 'Leverage',
	dash_currency: 'Currency',
	dash_marketSummary: 'Market Summary',
	dash_marketInsight: 'Market Insights',
	dash_news: 'News',
	dash_EconomicCal: 'Economic Calendar',
	dash_thereIsNoRecord: 'No records found',
	dash_Time: 'Time',
	dash_Country: 'Country',
	dash_event: 'Event',
	dash_frequency: 'Frequency: Monthly',
	dash_autochartist: 'AutoChartist',
	dash_nodata: 'No Data',
	dash_time: 'Time',
	dash_impact: 'Impact',
	dash_actual: 'Actual',
	dash_forecast: 'Forecast',
	dash_previous: 'Previous',

	//========download platform
	dp_download: 'Download',
	dp_actTrader: 'ActTrader<sup>TM</sup>',
	dp_forWindows: 'For Windows',
	dp_forIos: 'For iOS',
	dp_forAndroid: 'For Android',
	dp_ActWebTrader: 'Act Web Trader',
	dp_MT4WebTrader: 'MT4 Web Trader',
	dp_forMAC: 'For MAC',
	dp_MT5WebTrader: 'MT5 Web Trader',
	forWindows: 'Windows',
	forIos: 'iOS',
	WEB: 'Web',


	//======================account==========================
	//=========account

	acc_Aclist: 'Account List',
	acc_changeLeverage: 'Change Leverage',
	acc_changeplatPass: 'Change Platform Password',
	acc_InternalTrans: 'Internal Transfer',

	//=============================bank================================
	//===========bank

	bnk_bankDetails: 'Bank Details',
	bnk_MicrCode: 'Micr Code:',
	bnk_IBANNumber: 'IBAN Account Number',
	bnk_ifscSwiftBic: 'ifsc/Swift/Bic (Short code of uk)',
	bnk_Save: 'Save',

	//============================bonus===============================
	//=========deposit-bonus

	db_requestBon: 'Request Bonus',
	db_removeBon: 'Remove Bonus',
	db_bonusList: 'Bonus List',

	//===========bonus-verify 
	bver_bonusVerMsz1: 'Your bonus request has been processed successfully.',
	bver_backBonusList: 'Back To Bonus List',
	bver_reqFailed: 'Request Failed',

	//============bonus-list
	bl_bonusList: 'Bonus List',
	bl_created: 'Date',
	bl_amount: 'Amount',
	bl_bonusType: 'Bonus Type',
	bl_status: 'Status',
	bl_comments: 'Comments',
	bl_complete: 'Complete',
	bl_pending: 'Pending',

	//============remove bonus
	rb_removeBonus: 'Remove Bonus',
	rb_removebonusMsz1: 'Sorry you are not eligible to remove bonus.',
	rb_availbonus: 'Available Bonus:',
	rb_bonusremove: 'Enter bonus amount to remove',
	rb_submit: 'Submit',
	rb_googleAuth1: 'Please enter the 6 digit One-Time Pin shown in the',
	rb_googleAuth2: 'Google Authenticator',
	rb_googleAuth3: 'app',
	rb_validate: 'Validate',
	rb_googleAuth4: 'Having Trouble with your Two-Factor Authentication Code?',
	rb_googleAuth5: 'Click Here to verify with Email',
	rb_googleAuth6: "We've sent a link to your email",
	rb_bonusGoogleAuth: 'Kindly click on the link in order to proceed with your withdrawal',
	rb_googleAuth7: "Haven't received an email in your inbox or spam folder? Resend",
	rb_googleAuth8: 'Two-factor authentication is not enabled on your account.',
	rb_googleAuth9: "Two-factor authentication adds an extra layer of security, ensuring that it's really you who is trying to make changes in your fxview account.",
	rb_googleAuth10: 'Click Here to enable Google authentication',
	rb_congo: 'Congratulations',
	rb_removeBonusCongoMsz: 'Bonus has been removed successfully forTrading Id',
	rb_goToDash: 'Go to dashboard',
	rb_noTradingAccFound: 'No Live Trading Account Found!',
	rb_plzWaitWhileProc: 'Please wait while we are processing your data...',
	rb_bonusGooglerequest: 'Kindly click on the link in order to proceed with your bonus request',
	rb_bonusGoogleremove: 'Kindly click on the link in order to proceed',

	//==============request bonus

	req_bonus: 'Bonus',
	req_bonusMsz1: 'Sorry you are not eligible. Fund your account to avail bonus.',
	req_allowMaxBonus: 'Maximum bonus allowed',
	req_amount: 'Amount',
	req_agreeTerms: 'I agree to the terms and conditions',
	reg_Agreee: 'I agree to the',
	reg_TERMS: 'terms and conditions',
	req_fieldReq: 'Field is required',
	req_maxlev: 'Maximum Leverage allowed to avail 100% deposit bonus is 300X. ',
	req_tochangeleverage: 'to change your leverage',
	req_bonusMsz2: 'Bonus has successfully been added for Trading ID:',
	req_availBonus: 'Use Bonus',
	req_allowBonus: 'Allowed Bonus',
	req_goBackMangeAcc: 'Go to Manage Account',
	req_noTradingAccFound: 'No Live Trading Account Found!',
	req_minBonus: 'minimum deposit bonus is 200 dollar and we are getting option to deposit is',
	req_maxAmount: 'Max amount you can request for bonus is ',
	rb_ReadPolicy: 'Read Our Bonus Policy',

	//==================================deposit======================================
	//============deposit
	dep_acc_fund_depFundAcc: 'Deposit Funds to Account',
	dep_acc_fund_tradAccId: 'Trading Account ID',
	dep_acc_fund_depFund: 'Deposit Funds',
	dep_acc_fund_selDepMet: 'Select Deposit Method',
	dep_acc_fund_depFieldReq: 'DepositMethod field is required',
	dep_selectbankaccount: 'Please Select Bank Account :',
	dep_acc_fund_lessDet: 'Less Detail',
	dep_acc_fund_viewDet: 'View Detail',
	dep_holderName: 'Holder Name:',
	dep_sortCode: 'Sort Code',
	dep_reference: 'Reference',
	dep_fortradaccount: 'For trading account',
	dep_selectAcc: 'Please Select Account',
	dep_acc_fund_DontbankAcc: "you don't have any bank account , please",
	dep_acc_fund_clkHere: 'Click Here',
	dep_Createbank: 'to create new bank',
	dep_acc_fund_MinDepAmt: 'Minimum Deposit Amount',
	dep_acc_fund_SpeDepAm: 'Specify the deposit amount',
	dep_mindepositallow: 'Minimum deposit allowed',
	dep_acc_fund_bakStp: 'Previous step',
	dep_acc_fund_procToPay: 'Proceed To Payment',
	dep_ticketHasbeenCreated: 'Your ticket has been created',
	dep_proMsz19: 'Go to Tickets',
	dep_acc_fund_PlsEnsCort: 'Please ensure that details are correct',
	dep_acc_fund_accountId: 'Account ID/Wallet No.',
	dep_acc_fund_feeUsd: 'Fee (USD)',
	dep_acc_fund_depAmt: 'Deposit Amount',
	dep_acc_fund_depMeth: 'Deposit Method',
	dep_acc_fund_noTrdAccFnd: 'No Live Trading Account Found!',
	dep_acc_fund_plzWaitWhileProc: 'Please wait while we are processing your data...',
	dep_maxlimit: 'you have raised max limit of transaction per month',
	dep_maxdeposit: 'you can deposit maximum amount = ',
	dep_pleaseDeposit: 'I want to deposit',
	dep_pleaseDeposit1: 'from by bank detail as mentioned below <br>',
	dep_AccNumber: 'Account Number : ',
	dep_holdername: '<br> Holder Name :',
	dep_bankname: '<br> Bank Name :',
	dep_brsortCode: '<br> Sort Code :',
	dep_brbankAdress: '<br> Bank Address :',
	dep_depositDone: 'deposit done successfully',
	dep_depositFail: 'deposit failed',

	//=========deposit list

	dl_depositList: 'Deposit List',
	dl_transId: 'Transaction Id',
	dl_status: 'Status',
	dl_Method: 'Method',
	dl_type: 'Type',
	dl_created: 'Date',
	dl_action: 'Action',

	//==============deposit transaction
	dt_depTransHist: 'Deposit Transaction history',
	dt_payMeth: 'Payment Method',
	dt_clickToResolve: 'click to resolve',

	//=============deposit wallet
	dw_acc_fund_selDepMet: 'Select Deposit Method',
	dw_acc_fund_depFieldReq: 'DepositMethod field is required',
	dw_selectaccount: 'Please Select Bank Account :',
	dw_acc_fund_lessDet: 'Less Detail',
	dw_acc_fund_viewDet: 'View Detail',
	dw_holderName: 'Holder Name:',
	dw_bankName: 'Bank Name:',
	dw_bankAdd: 'Bank Address:',
	dw_sortCode: 'Sort Code',
	dw_reference: 'Reference',
	dw_fortradingAcc: 'For trading account',
	dw_acc_fund_DontbankAcc: "you don't have any bank account , please",
	dw_Createbank: 'to create new bank',
	dw_acc_fund_MinDepAmt: 'Minimum Deposit Amount',
	dw_acc_fund_SpeDepAm: 'Specify the deposit amount',
	dw_acc_fund_PlsEnsCort: 'Please ensure that details are correct',
	dw_acc_fund_accountId: 'Account ID',
	dw_acc_fund_feeUsd: 'Fee (USD)',
	dw_acc_fund_depAmt: 'Deposit Amount',
	dw_acc_fund_depMeth: 'Deposit Method',
	dw_proMsz19: 'Go to Tickets',
	dw_acc_fund_plzWaitWhileProc: 'Please wait while we are processing your data...',
	dw_bankCode: '<br> Bank Code : ',

	//========================manage accounts=================================
	//===========account-verify 
	acc_reqProcessing: 'request processing...',
	acc_accountVerMsz1: 'request has been processed successfully',
	acc_backAccountList: 'Back to Account List',
	acc_reqFailed: 'Request Failed',

	//===========account-list

	acclist_myAccounts: 'My Accounts',
	acclist_liveAccount: 'Live Accounts',
	acclist_demoAccount: 'Demo Accounts',

	//=========change-leverage
	lev_changeLeverage: 'Change Leverage',
	lev_exsistLev: 'Existing Leverage',
	lev_newLev: 'New Leverage',
	lev_backManageAccount: 'Back To Manage Account',
	lev_levMsz1: 'Please click on the link to change your leverage.',
	lev_levMsz2: 'Your trading account leverage has been changed successfully',
	lev_tradingId: 'Trading Ideas',
	lev_oldLev: 'Old Leverage',
	lev_goBackMangeAccv: 'Go to Manage Account',
	lev_noDemoLiveTradingAccFound: 'No Trading Account Found!',
	lev_waitforVerf: 'Please wait for the Verification.',

	//==========change leverage password
	levPwd_passMsz1: 'Please click on the link to change your password',
	lePwd_passMsz2: 'Your trading account password has been changed successfully',
	lePwd_oldPassword: 'Old Password',

	//========demo account list
	Dlist_demoLive: 'Demo/Live',
	Dlist_accountType: 'Account Type',
	Dlist_leverage: 'Leverage',

	//=======detach account
	detch_detachaccount: 'Detach account:',
	detch_fourfive: '454579',
	detch_pamMaster: 'Pamm master:',
	detch_todd: 'Todd Anderson',
	detch_balance: 'Balance',
	detch_equity: 'Equity',
	detch_freeMargin: 'Free Margin',
	detch_MarginUSed: 'Margin Used',
	detch_pnl: 'PnL',
	detch_two: '$2000',
	detch_eight: '$800',
	detch_twelve: '$1200',
	detch_three: '$300',
	detch_twofive: '$-250',
	detch_takenote: 'Please take note of below points',
	detch_openPosition: 'All open positions will be closed before detaching the account.',
	detch_finalPnl: 'The final PnL might vary according to market conditions.',
	detch_afterOpen: 'After open positions are closed, Management, Subscription Cost, Performance fee will be calculated and deducted from the account, if any.',
	detch_terms: 'I accept the above terms and conditions',
	detch_confirm: 'Confirm',

	//=======internal transfer
	It_oneRecord: 'You  only have  one record. Please create at least one more trading account or wallet before attempting an internal transfer',
	It_liveAcc: 'Live Account',
	It_wallet: 'Wallet',
	It_internalTransfer: 'Internal Transfer',
	It_confToTransfer: 'Please Confirm to Continue',
	It_back: 'Back',
	It_freeMargin: 'Free Margin',
	It_interTransSorryMsz: "Sorry you don't have balance to transfer amount to another trading account.",
	It_transToAcc: 'transfer to account id',
	It_fieldReq: 'Field is required',
	It_currentBalance: 'Current Balance',
	It_pleseEnterAmount: 'please enter amount',
	It_submit: 'Submit',
	It_confToTransfer: 'Please Confirm to Continue',
	It_intTransMsz2: 'Please click on the link to confirm your internal transfer',
	It_intTransMsz3: 'The transfer has been completed successfully',
	It_fromTradId: 'From Trading ID',
	It_towallet: 'To Wallet',
	It_toTradId: 'To Trading ID',
	It_transferAmount: 'Transferred Amount',
	It_backinternalTrans: 'Back to internal transfer',
	It_interTransDeducted: 'will be deducted from your',
	It_depostotradAcc: 'will be deposited to your',

	//==========internal transfer wallet
	Itwallet_backwallet: 'Back to wallet',
	Itwallet_cancel: 'Cancel',
	Itwallet_fromwal: 'from wallet',
	Itwallet_towal: 'To Wallet',
	Itwallet_backtowallet: 'Back to wallet',

	//===========subscribe account

	sub_SubliveAcc: 'Subscribe Live Account',
	sub_subscribe: 'Subscribe',
	sub_backtradingTool: 'Back to Trading tool box',
	sub_enterotp: 'Enter Otp',
	sub_validate: 'Validate',
	sub_resendOtp: 'Resend Otp',
	sub_congo: 'Congratulations',
	sub_tradingId: 'Trading ID',
	sub_addtradertool: 'Please Add Add Trader Tool Box per following details <br> account_id : ',

	//==========================research=================================================
	//==========research and education 
	re_marketinsight: 'Market Insights',
	re_news: 'News',

	//======pages
	//============basic education
	edu_learnTrade: 'Learn to Trade',
	edu_offerEdu: 'We offer you educational resources to learn all about trading. Our learning materials cater to all knowledge levels, and enable you to enhance your understanding of the global markets, online trading and our trading tools. Our comprehensive list of trading topics ranges from basic to advanced, and will help you elevate your trading to a higher level.',
	edu_Enhance: 'Enhance your understanding of the global markets and take your trading to the next level by tapping into our educational resources. Fxview education offers an extensive list of topics that cater to all levels of traders - from beginners to advanced - and covers both how the markets work, as well as how to use our trading tools to your advantage.',
	edu_tradeconfidence: 'You will learn to trade with confidence by focusing on both the technical and fundamental aspects of trading/investment with our help and support throughout',
	edu_basic: 'Basic',
	edu_advance: 'Advanced',
	edu_general: 'General',
	edu_forex: 'Forex',
	edu_commodities: 'Commodities',
	edu_indices: 'Indices',
	edu_stocks: 'Stocks',
	edu_thereIsNoRecord: 'No records found',

	//=============market-insight 
	marin_source: 'Source: hoopsAI',
	marin_loadmore: 'Load More',
	marin_loadwait: 'Loading please Wait...',

	//============market news
	news_marketnews: 'Market News',
	news_fearurednews: 'Featured News',
	news_market: 'Market',
	news_nodata: 'No Data',
	news_latestnews: 'Latest News',

	//=============video tutorial 

	video_video: 'Video',
	video_tut: 'Tutorials',
	video_intrestedforex: 'Interested in forex trading? You are in the right place. Fxview offers a series of video tutorials to help you develop your skills and learn to trade like the pros. Our step-by-step guides include instructions on registration, account verification, basic forex terminology, trading platform functionality, and much more.',
	video_allvideo: 'All Videos',
	video_fxviewtut: 'Fxview Tutorials',
	video_platTut: 'Platform Tutorials',
	video_forexBasic: 'Forex Basics',
	video_whatisforex: 'What is the forex',


	//========webinare fxview
	web_webinars: 'Webinars',
	web_enhancetrad: 'Enhance your trading by signing up to our free webinars and learning from experts. Our webinars are specifically designed to boost your market knowledge and hone your trading skills. Experts reveal key trading strategies and  concepts, which can benefit both beginners and experienced traders.',
	web_registeran: 'Register for an',
	web_upcomingweb: 'upcoming webinar',
	web_register: 'Register',
	web_timeleft: 'Time Left',
	web_days: 'DAYS',
	web_hours: 'HOURS',
	web_mins: 'MINUTES',
	web_secs: 'SECS',
	web_webnar: 'Webinar',
	web_library: 'library',
	web_higherpower: 'Trendlines-Webinar',
	web_aprtwenty: '(9th August 2021)',
	web_findright: 'Support and Resistance-Webinar',
	web_aprsixteen: '(11th August 2021)',
	web_weekahead: 'Basic Indicators-Webinar',
	web_aprtwelve: '(13th August 2021)',
	web_introTrend: 'Introduction To Trend Indicators - Webinar',
	web_apreighteen: 'Mar 18th',
	web_topicdiscuss: 'TOPIC OF DISCUSSION',
	web_correlation: 'FXVIEW-Using Correlation To Improve Your Trading',
	web_datemay: 'May 11, 2021 12:00 - 12:40 pm GMT',
	web_showlocal: 'Show my local time',
	web_joinfxview: 'Join Fxview expert as he gives you insights regarding using of correlation so as to improve your trading skills.',
	web_secureplace: 'Secure your place with industry expert and learn what it takes to be a professional Forex trader',
	web_topicsCovered: 'TOPICS TO BE COVERED DURING WEBINAR',
	web_strongweak: '- Strong vs weak correlation',
	web_corrmultiple: '- Correlation across multiple timeframes',
	web_posneg: '- Understanding positive and negative correlation',

	//==============forex-glossary
	ForexGlossarySpan: "Forex  <span>Glossary</span>",
	ForexGlossaryGuide: "Fxview's forex glossary is a complete guide to help you learn basic forex terminology and become familiar with trader's lingo.",
	AGGREGATE_DEMAND: 'AGGREGATE DEMAND',
	text: 'It is an economic measurement of the total demand for all the finished goods and services in an economy/sector. It indicates how current price levels relate to a nation’s real GDP (Gross Domestic Product).',
	APPRECIATION: 'APPRECIATION',
	AppText: 'It refers to an increase in the value of one currency in relation to another currency in response to market demand.',
	ARBITRAGE: 'ARBITRAGE',
	ArbText: 'The purchase of a financial asset in one market and concurrent sale in another market to benefit from the price differentials is known as arbitrage.',
	AROUND: 'AROUND',
	ArndText: 'Dealer jargon used in quoting when the forward premium/discount is near parity. For example, “two-two around” would translate into 2 points to either side of the present spot.',
	ASK_RATE: 'ASK RATE',
	Asktext: 'The rate/price at which a financial instrument is offered for sale.',
	ASSET_ALLOCATION: 'ASSET ALLOCATION',
	AsstText: 'An investment strategy that aims to balance risk and reward by allocating funds to different stocks, bonds, commodities, currencies and other asset classes as per investors objectives.',
	Back_office: 'Back office',
	BalanceofTrade: 'Balance of Trade',
	BarCharts: 'Bar Charts',
	BaseCurrency: 'Base Currency',
	BearMarket: 'Bear Market',
	BidRate: 'Bid Rate',
	btext1: 'The departments check all the settlement and related processes',
	btext2: 'The difference in value between a country’s exports and imports.',
	btext3: 'Bar charts are used in financial markets to convey price movements into an easily readable chart. They are basically an OHLC graphical chart used for charting prices. There is a tick on the chart which provides the price a given time period at open, high, low and close.',
	btext4: 'A currency which appears in a forex pair quotation. There is always one currency in the forex market which is always quoted in relation to another as you are buying one while selling the other. The base currency will appear first, followed by the second (quote) currency. For instance, if you are looking at the EUR/USD pair,here the base currency is the Euro and quote currency is the US dollar.',
	btext5: 'A market characterized by falling prices.',
	btext6: 'The maximum price that a buyer is willing to pay for.',
	CABLE: "CABLE",
	CABLEText: "A nickname used for GBP/USD pair. The term originated because of the fact that the rate was originally transmitted via a transatlantic cable beginning in the mid 1800’s, when GBP was the currency of international trade.",
	CANDLESTICK_CHART: "CANDLESTICK CHART",
	CANDLESTICK_CHARTText: "Also called the Japanese candlestick chart, is a type of bar chart used essentially to describe the price movements of a security, derivative or currency. Each “candlestick” typically shows one day and represents the difference between opening and closing price. If opening price is higher than closing price, the candle/rectangle is shaded. If closing price is higher than the opening price that area of the chart is not shaded.",
	CENTRAL_BANK: "CENTRAL BANK",
	CENTRAL_BANKText: "A government or quasi governmental organization that oversees a country’s  monetary policies and prints currencies. For example – The Federal Bank Reserve (U.S), The European Central Bank (Europe), Reserve Bank of Australia (Australia).",
	CHARTISTs: "CHARTIST",
	CHARTISTsText: "An individual (also known as a technical trader) who uses charts and graphs to interpret historical data in order to find trends and predict future price movements.",
	CHOICE_MARKET: "CHOICE MARKET",
	CHOICE_MARKETText: "Also referred to as a locked market, its a market with no spread. It means that a currency can be bought at the same price as it can be sold in the market.",
	CLEARING: "CLEARING",
	CLEARINGtext: "Process of reconciling or settling purchases and sales of various financial instruments.",
	CONTAGION: "CONTAGION",
	CONTAGIONText: "Tendency of an economic crisis to spread from one market to another.",
	COLLATERAL: "COLLATERAL",
	COLLATERALText: "Something given by a borrower to secure a loan or as a guarantee of performance.",
	COMMISSIONs: "COMMISSION",
	COMMISSIONText: "A transaction fee charged by the broker from the traders/investors. ",
	CONFIRMATION: "CONFIRMATION",
	CONFIRMATIONText: "Documents exchanged by counterparts to a transaction that states the terms of said transaction.",
	CONTRACTunit: "CONTRACT(unit or lot)",
	CONTRACTunitText: "The standard unit of  trading.",
	COUNTERPARTY: "COUNTERPARTY",
	COUNTERPARTYText: "One of the participants, either a bank or customer ,with whom a financial transaction is made.",
	COUNTRY_RISK: "COUNTRY RISK",
	COUNTRY_RISKText: "Risks associated with cross border transactions such a legal and political conditions like war. ",
	CROSS_RATES: "CROSS RATES",
	CROSS_RATESText: "Exchange rates between two currencies that do not involve the U.S Dollar. A cross rate is said to be non standard in the country where the currency pair is quoted.",
	CURRENCYe: "CURRENCY",
	CURRENCYText: "A means of exchange in the form of paper, metal or digital issued by a government/ central bank and used as legal tender. ",
	CURRENCY_RISK: "CURRENCY RISK",
	CURRENCY_RISKText: "Risk of incurring losses due to an adverse change in exchange rates.",
	Day_trading: "Day trading",
	Day_tradingText: "A trading strategy involving opening and closing positions within the same day.",
	Dealer: "Dealer",
	DealerText: "A person who acts as a principal or counterpart to a transaction. Principal basically is on one side in the hopes of earning good profit by closing out the position in a subsequent trade with another party.",
	Deficit: "Deficit",
	DeficitText: "An amount by which the cost of a countrys imports exceeds the cost of its exports or also called as a negative balance of trade.",
	Delivery: "Delivery",
	DeliveryText: "The settlement of a transaction by delivery of funds. OR The date of maturity of a contract, when the final settlement of a transaction is made by exchanging the currencies.",
	Depreciation: "Depreciation",
	DepreciationText: "Decline in a currency’s value relative to another currency either due to market conditions or other factors.",
	Derivative: "Derivative",
	DerivativeText: "Derivatives derive their value from the price of an underlying asset and often used by traders as an instrument to speculate on the future price movements of an asset without having to buy the asset itself. Option is the most common derivative instrument.",
	Devaluation: "Devaluation",
	DevaluationText: "A currency devalues when it’s value declines in relation to one or more other currencies.",
	ECONOMIC_INDICATOR: "ECONOMIC INDICATOR",
	ECONOMIC_INDICATORText: "A statistical measure issued by the government or a non government institution that indicates the economic condition of an economy like GDP, Foreign investment, Trade deficits, Employment rates, etc.",
	ENDOFDAYORDER: "END OF DAY ORDER",
	ENDOFDAYORDERText: "An order to buy or sell at a specified price that is only open until the end of the trading day, typically 5 PM/17:00  New York time.",
	EUROs: "EURO",
	EUROsText: "Currency of the European Monetary Union(EMU).",
	EUROPEANCENTRALBANK: "EUROPEAN CENTRAL BANK",
	EUROPEANCENTRALBANKText: "Established in 1998, its the Central Bank for the European Monetary Union (EMU).",
	FederalDepositInsurance: "Federal Deposit Insurance Corporation(FDIC)",
	FederalDepositInsuranceText: "An independent federal agency protecting consumers and the U.S. financial system. The FDIC is the best known for deposit insurance as they help customers avoid losses in the event of bank failures.",
	FederalReserveSystem: "Federal Reserve System",
	FederalReserveSystemText: "The most powerful financial institution in the world. The Federal Reserve System was founded by the U.S. congress in 1913 with an aim of providing stable monetary system and comprises a central government agency and 12 regional federal reserve banks.",
	FixedExchangeRate: "Fixed Exchange Rate",
	FixedExchangeRateText: "An exchange rate regime where a currency’s value is set by a monetary authorities against the value of one or more currencies.",
	FloatingExchangeRate: "Floating Exchange Rate",
	FloatingExchangeRateText: "An exchange rate regime where the currency’s value is fixed by the forex market based on demand and supply relative to other currencies.",
	Flatsquare: "Flat/square",
	FlatsquareText: "Dealer jargon used to describe a position that has been completely reversed. For instance, you bought $100,000 then sold $100,000, hence creating a flat position.",
	Foreign_Exchange: "Foreign Exchange",
	Foreign_ExchangeText: "Foreign Exchange is the exchange of one currency for the other. It is the global online network where traders buy and sell currencies. It has no physical location and operated 24 hours a day.",
	Forward: "Forward",
	ForwardText: "Pre specified rate to lock in a price at a specific future time, based upon the interest rate differential between the two currencies involved.",
	Forward_Contracts: "Forward Contracts",
	Forward_ContractsText: "An agreement between the two parties to buy or sell an asset at a specified rate on a pre specified expiry date. Both the parties are obliged to fulfill their end of the agreement.",
	ForwardRates: "Forward Rates(swaps)",
	ForwardRatesText: "Forward Rate is a cash price of 2 currencies interest difference for a fixed period and can be easily calculated provided the fixed interest rates of each currency and the current spot rate is given.",
	Forward_Trading: "Forward Trading",
	Forward_TradingText: "Forward Trading is making the opposite trade of a spot trade at given time. Traders often swap their trades forward ranging from a week to months. Even though the forward contract occurs on a future date, still the position can be closed out at any time. Then that closing part of the position is swapped forward to the same future value date.",
	Forwardpoints: "Forward points",
	ForwardpointsText: "Simply the pips which are added or subtracted from the current exchange rate to compute a forward price.",
	Fundamental_Analysis: "Fundamental Analysis",
	Fundamental_AnalysisText: "Method of analyzing the factors that may influence the price in the future. This form of analysis is based on external events and influences as well as industry trends where as technical traders derive information from charts and patterns.",
	FuturesContract: "Futures Contract",
	FuturesContractText: "A legal agreement between two parties to trade at a predetermined price, on a predetermined date in the future. Futures are traded over an exchange and can be used to gain exposure to a wide range of assets.",
	Gearing: "Gearing",
	GearingText: "When a trader is trading on a partial debt or margin.",
	GroupofFive: "Group of Five (G5)",
	GroupofFiveText: "Five leading industrial nations- France, Japan, UK, Germany and US which meet from time to time with the motive to discuss common economic problems.",
	GroupofSeven: "Group of Seven (7)",
	GroupofSevenText: "The “Group of Seven” are 7 leading non-communist industrialized countries comprised of France, Germany, UK, Germany and US plus Canada and Italy. They are now known as the G8 since the addition of Russia.",
	GroupofTen: "Group of Ten (G10)",
	GroupofTenText: "Also called “The Paris Club” composed of Canada, Belgium, France, Germany, Italy, Sweden, Japan, UK, US and the Netherlands. It was formed in 1962 to make the funds available to the IMF and assist member countries with balance of payment difficulties.",
	GoldilocksEconomy: "Goldilocks Economy",
	GoldilocksEconomyText: "A term which is used to describe an economy that is not too hot or too cold and sustains moderate growth with nominal rate of inflation, that allows a market friendly monetary policy.",
	GoodtilCancel: "Good ‘til Cancelled (GTC)",
	GoodtilCancelText: "An order that is valid until it is canceled or completed irrespective of the amount of time when the order was placed. ",
	HEDGING: "HEDGING",
	HEDGINGText: "A risk management strategy whereby investors ‘hedge’ to protect themselves from adverse price movements by taking two opposing positions and thereby reduce risk. In the context of currency transactions it would protect one against fluctuations in the forex exchange rate. ",
	INFLATION: "INFLATION",
	INFLATIONText: "A continuous increase in the general price level of consumer goods, which erodes the purchasing power.",
	INITIALMARGIN: "INITIAL MARGIN",
	INITIALMARGINText: "The initial deposit of collateral required to enter into a position as a guarantee on future performance.",
	INTERBANKRATES: "INTER BANK RATES",
	INTERBANKRATESText: "The foreign exchange rates at which large international banks quote other large international banks.",
	LEADINGINDICATORS: "LEADING INDICATORS",
	LEADINGINDICATORSText: "Economic variables considered to predict future economic activity.",
	LEVERAGEs: "LEVERAGE",
	LEVERAGEsText: "Leverage is offered by brokers to maximize trader’s buying power. It can be described as ‘borrowed capital’ from a traders point of view and increases your potential returns since you can trade much bigger volumes with these funds than your limited capital. It is expressed in ratios such as 1:100, 1:300 and so on. So with a leverage of 1:100 a trader’s buying power is magnified 100 times. <strong>Disclaimer:</strong> Leverage amplifies possible returns as well as losses.",
	LIBOR: "LIBOR",
	LIBORText: "The London Interbank offered Rate. It is the benchmark interest rate at which major global banks lend to each other.",
	LIMITORDER: "LIMIT ORDER",
	LIMITORDERText: "An order to execute a trade at a specified price or better. For example, if the current price of EUR/USD is 1.08502/1.08522, then a limit order to buy EUR would be at a price below the market price,1.0820.",
	LINECHARTS: "LINE CHARTS",
	LINECHARTSText: "A price chart connecting single prices (all closing prices) for a selected time period. ",
	LIQUIDITYs: "LIQUIDITY",
	LIQUIDITYsText: "A currency pair’s ability to be bought and sold in the market without causing a significant change in its exchange rate.",
	LIQUIDATION: "LIQUIDATION",
	LIQUIDATIONText: "Closing of an existing position through execution of an offsetting transaction.",
	LONGPOSITION: "LONG POSITION",
	LONGPOSITIONText: "A position is said to be ‘long’ if it appreciates in value when market prices increase. When one buys a currency pair, their position is long on that pair.",
	Margins: "Margin",
	MarginText: "Margin is the amount of money which is required to keep a margin position open. It is the difference between the full value of your position and the funds being lent to you by a broker/leverage provider.",
	MarginDeposit: "Margin Deposit",
	MarginDepositText: "A margin deposit is the initial amount of money a trader requires to put down down in order to open a leveraged trading position. It can also be known as initial margin, deposit or simply deposit.",
	MarginCall: "Margin Call",
	MarginCallText: "A margin call can be described as an alert/request/call from your broker to notify you that your maintenance margin has fallen below the minimum and your position is at risk of being liquidated. So, in such a case a broker asks a client to top up their account to maintain the existing position open.",
	MarketMaker: "Market Maker",
	MarketMakerText: "A dealer who maintains a firm bid and ask price and is ready to make two sided market for any financial instrument.",
	MarketRisk: "Market Risk",
	MarketRiskText: "Exposure to changes in market prices.",
	Marktomarket: "Mark to market",
	MarktomarketText: "Adjusting/Evaluating all open positions in accordance with the current market prices.",
	Maturity: "Maturity",
	MaturityText: "The settlement or expiry date of a financial instrument.",
	NarrowMarket: "Narrow Market",
	NarrowMarketText: "Exchange market also characterized by Thin Market where there is a low number of buyers and sellers and prices tend to be volatile.",
	Offer_s: "Offer",
	OfferText: "The same as the ask price, the price at which a dealer is willing to sell for.",
	Offsettingtransaction: "Offsetting transaction",
	OffsettingtransactionText: "Offsetting can mean closing a position to cancel or offset some or all of the market risk of an open position.",
	OneCancelsOrder: "One Cancels the Other Order (OCO)",
	OneCancelsOrderText: "When you put a stop order and a limit order and if either one is executed the other order will automatically be canceled.",
	Openorder: "Open order",
	OpenorderText: "An order that has no specific expiration date and executed when a specific market price is reached. They are generally associated with GTC orders.",
	Open_position: "Open position",
	OpenPositionText: "A position which is still active and not yet closed or reversed.",
	OvertheCounter: "Over the Counter (OTC)",
	OvertheCounterText: "OTC trading is for the securities of those companies which aren't listed on any central exchange and so buying and selling of such securities is done over the counter, that is, through private brokers and dealers, who directly negotiate with buyers and sellers.",
	Overnight: "Overnight",
	OvernightText: "A trade/position that stays open until the next business day.",
	Pip_s: "Pips",
	PipText: "The smallest amount of change in a quoted forex price. Most major currencies define a pips as the fourth decimal place, so a one pip change is equivalent to 0.0001 except the Japanese Yen where a pip is the second digit after the decimal point.",
	PoliticalRisk: "Political Risk",
	PoliticalRiskText: "Due to changes or instability in government policy, adverse effect on an investor’s positions/returns.",
	PointFigureCharts: "Point & Figure charts",
	PointFigureChartsText: "The Point & Figure Chart doesn’t take into consideration Time and completely focus on price movements and trends in the asset.",
	Position_s: "Position",
	PositionText: "Position is the financial term for a trade that is either currently active and able to incur loss/gain called open position or a trade that has recently been closed known as closed position.",
	Premium: "Premium",
	PremiumText: " The amount by which the future or forward price exceed the spot price.",
	PriceTransparency: "PriceTransparency",
	PriceTransparencyText: " Elucidate quotes to which every market participant can have equal access",
	Quote_s: "Quote",
	QuoteText: "A price at which an asset was last traded or can be currently bought or sold and used for additional information only.",
	RATE_s: "RATE",
	RATEText: "The price of one currency in terms of the other, whose values change relative to each over time.",
	RESISTANCE_s: "RESISTANCE",
	RESISTANCEText: "A commonly used technical analysis term that indicates a specific price level at which a currency will have the inability to cross over. Such a price acts as a ceiling.",
	REVALUATION: "REVALUATION",
	REVALUATIONText: "The opposite of devaluation, revaluation is an upward adjustment to a country’s official exchange rate as a result of central bank intervention. ",
	REVALUATIONRATES: "REVALUATION RATES",
	REVALUATIONRATESText: "These are market rates used as a base value by traders to assess whether profit/loss has been realized for the day or overall. Usually revaluation rate is the closing rate for the previous trading day. ",
	RISK_s: "RISK",
	RISKText: "Potential of a negative outcome such as under performance, failure to achieve trading/investment goals or losing money or adverse changes. ",
	RISKCAPITAL: "RISK CAPITAL",
	RISKCAPITALText: "The amount of money an individual is able to invest, the loss of which shall not result in a substantial change to their lifestyle. ",
	RISK_MANAGEMENT: "RISK MANAGEMENT",
	RISKMANAGEMENTText: "All techniques and strategies used to mitigate and/or control the inherent risks in trading and investment such as using stop losses, hedging,diversifying etc. ",
	ROLLOVER: "ROLL OVER",
	ROLLOVERText: "It is the simultaneous closing of an open position for today’s value date and the opening of the same position for the next day’s value date at a price reflecting the interest rate differentials between two currencies.",
	ROLLOVERRATE: "ROLL OVER RATE",
	ROLLOVERRATEText: "The interest paid or earned overnight for holdings the position/s, depending on the established margin and position in the market.",
	SETTLEMENT: "SETTLEMENT",
	SETTLEMENTText: "The transfer of ownership of a financial instrument to a buyer. The settlement of currency trades may or may not involve the actual physical exchange of one currency to another.",
	SHORTPOSITION: "SHORT POSITION",
	SHORTPOSITIONText: "A position is said to be short when a trader sells a security first with the intention of repurchasing it later when the price falls. Such a position is taken when he believes that prices are likely to fall in the near future.",
	SLIPPAGE: "SLIPPAGE",
	SLIPPAGEText: "Slippage occurs when the bid/ask spread changes between the time when an order is requested till the time the order is executed. This usually happens during periods of high volatility and occurs in all markets such as equity, bonds, currencies and futures.",
	SPOTNEXT: "SPOT/NEXT",
	SPOTNEXTText: "Also known as “next business day, it denotes the delivery of a purchased currency on a day after the spot date. They are short term swaps where a currency is rolled out one further day i.e after spot. ",
	SPOTPRICE: "SPOT PRICE",
	SPOTPRICEText: "The current market price of a financial instrument. ",
	SPOTRATE: "SPOT (RATE)",
	SPOTRATEText: "The current exchange rate at which a currency can be bought or sold. It is the rate quoted in the retail market with no adjustment for interest rate differential. ",
	SPOTTRADE: "SPOT TRADE",
	SPOTTRADEText: "It refers to the purchase and sale of a financial product for instant delivery on a specified spot date. Also known as a spot transaction and are typically settled electronically. ",
	Spread_s: "Spread",
	SpreadText: "A spread in trading means the range/difference between the bid and ask price quoted for a currency pair.",
	Sterling: "Sterling",
	SterlingText: "A term for the British Pound.",
	StopLossOrder: "Stop Loss Order",
	StopLossOrderText: "An order type to sell a currency when the price reaches or falls below the specified price. This is used to limit loss, usually when the price can not be actively monitored by the trader.",
	StochasticOscillator: "Stochastic Oscillator",
	StochasticOscillatorText: "The term Stochastic refers to the point of a current price in relation to its price range over a period of time. Stochastic Oscillator is a popular technical analysis indicator which states that during an upward trading market, prices tend to close near their high and vice versa.",
	SupportLevels: "Support Levels",
	SupportLevelsTexts: " This term indicates a specific price level at which a currency will have the inability to cross below. Support occurs when falling prices stop, change direction and begin to rise. Support level is often viewed as a “floor” which is supporting or holding up prices.",
	Swap_s: "Swap",
	SwapText: "Swap is a derivative contract through which two parties exchange cash flows or liabilities arising from two different financial instruments.",
	Swift: "Swift",
	SwiftText: "Society of Worldwide Interbank Financial telecommunications. It provides a dedicated computer network that enables financial institutions worldwide to support fund transfer messages in a secure, standardized and reliable environment.",
	TECHNICALANALYSIS: "TECHNICAL ANALYSIS",
	TECHNICALANALYSISText: "It involves the use of various technical indicators and analysis of market action through the study of charts, volume, trends, patterns, moving averages and various other technical indicators with the purpose of forecasting prices.",
	TICK_s: "TICK",
	TICKText: "A tick represents any single upcoming price quote, up or down.  ",
	TICKER: "TICKER",
	TICKERText: "It shows the current or recent history of a currency either in the format of  a table or a graph.",
	TOMORROWNEXT: "TOMORROW NEXT (TOM/NEXT)",
	TOMORROWNEXTText: "It is the simultaneous buying and selling of a currency for delivery the following day.",
	TRADING_s: "TRADING",
	TRADINGText: "The act of buying, selling , exchanging stocks, bonds or currencies etc.",
	TRANSACTIONCOST: "TRANSACTION COST",
	TRANSACTIONCOSTText: "Cost of buying and selling a financial instrument.",
	TRANSACTIONDATE: "TRANSACTION DATE",
	TRANSACTIONDATEText: "The Date on which a trade occurs.",
	TREND_s: "TREND",
	TRENDText: "A trend is simply the tendency of a price to move in a certain direction, up/down/reverse/sideways. They are usually broken down to three categories – major, intermediate and short term trends. ",
	TRENDLINE: "TRENDLINE",
	TRENDLINEText: " This is a very commonly used technical indicator for uncovering trends. A trendline connects two or more lows or more highs with the lines projected out into the future. It is calculated by using the “least squares method” and is also called linear regression.",
	TURNOVER: "TURNOVER",
	TURNOVERText: "It is the total money value of all executed transactions in a given time period. ",
	TWOWAYPRICE: "TWO WAY PRICE",
	TWOWAYPRICEText: "A two way quote indicates both the current bid price and current ask price of a security on a trading day.",
	UPTICK: "UPTICK",
	UPTICKText: "An uptick occurs when a security’s price rises in relation to the last tick. It is a new price quote at a price higher than the preceding quote. ",
	UPTICKRULE: "UPTICK RULE",
	UPTICKRULEText: "A trading restriction in the US that states that short selling is allowed only on an uptick. As per the rule, a security may not be sold short unless the last trade prior to the short sale was at a price lower than the price at which the short sale is executed.",
	USPRIMERATE: "US PRIME RATE",
	USPRIMERATEText: "The interest rate at which US banks will lend to their prime corporate customers.",
	VALUEDATE: "VALUE DATE",
	VALUEDATEText: "The date on which counterparts agree to settle their respective obligations. For spot currency transactions, value date is usually two business days forward. Also known as maturity date, it is the date on which transaction is settled. ",
	VARIATIONMARGIN: "VARIATION MARGIN",
	VARIATIONMARGINText: "Fund traders must hold in their accounts to keep a leveraged trade open.  The term usually refers to additional funds that must be deposited as a result of unfavorable price movements.",
	VOLATILITYVOL: "VOLATILITY (VOL)",
	VOLATILITYVOLText: "Characterized by rapid and random price movements, it is a term used to refer to active markets that often present trade opportunities.",
	VOLUME_s: "VOLUME",
	VOLUMEText: "Total number of contracts traded during a specific period.",
	WeakDollarStrongDollar: "Weak Dollar/ Strong Dollar",
	WeakDollarStrongDollarText: "The term weak and strong dollar are used in the foreign exchange market to describe the relative value and strength of the U.S. dollar against other currencies. Dollar is said to be weak when more dollars are required to buy one unit of another currency and strong when few dollars are required to buy one unit of another currency.",
	Whipsaw: "Whipsaw",
	WhipsawText: "A condition of extreme volatility when rapid growth of a price is followed by a drastic fall(or vice versa).",
	Yard: "Yard",
	YardText: "Forex term for a billion units",
	YIELD: "YIELD",
	YIELDText: "The income earned from an investment.",



	//======================register steps=======================================
	//=========steps
	steps_heading1: 'Personal Information',
	steps_heading2: 'Declaration',
	steps_heading3: 'Upload Personal Documents',

	//==========step1
	step1_personalinfo: 'Personal Information',
	step1_fname: 'First Name',
	step1_age_error: "Sorry, we only accept clients above 18 years of age",
	step1_lname: 'Last Name',
	step1_dob: 'DOB',
	step1_dobrequired: 'The DOB is required',
	step1_below18: 'Your Age is below 18',
	step1_addinfo: 'Address Information',
	step1_city: 'City',
	step1_postalcode: 'Postal Code',
	step1_countryRes: 'Country of Residence',
	step1_otherinfo: 'Other Information',
	step1_addInfo: 'Additional Information',
	step1_phno: 'Phone Number',
	step1_phnoRequired: 'The Phone number is required',
	step1_correctno: 'Please Enter the correct Phone number',
	step1_prefcurrency: 'Select Preferred Wallet Currency',
	step1_pep: 'Are you a Politically Exposed Person (PEP)?',
	step1_usPerson: 'Are you a US person?',
	step1_Next: 'Next',
	step1_firstmember: 'First Member Information',
	step1_member1dob: 'Member 1 Date Of Birth is required',
	step1_member1age: 'Member 1 Age is bellow 18',
	step1_secondmember: 'Second Member Information',
	step1_menber2dobreq: 'Member 2 Date Of Birth is required',
	step1_member2age: 'Member 2 Age is bellow 18',
	step1_adressinfo: 'Address Information',
	step1_companyinfo: 'Company Information',
	step1_companyname: 'Company Name',
	step1_incopDate: 'Incorporation Date ',
	step1_incodateReq: 'The Incorporation Date is required',
	step1_futuredate: 'future Date not allow',
	step1_authorperson: 'Authorised Person Information',
	step1_companyAdrsinfo: 'Company Address Information',
	step1_regAddone: 'Registered Company Address Line 1',
	step1_regAddtwo: 'Registered Company Address Line 2',
	step1_country: 'Country',
	step1_minimumph: 'The phone number includes atleast 8 characters',
	step1_maxphone: 'The phone number may not be greater than 15 characters',
	step1_stepMsz2: "A PEP is a natural person who has been entrusted with the following prominent public functions in any country, as well as his/ her immediate family members and persons known to be close associates of such a person: <ul> <li>Heads of State, heads of government, ministers and deputy or assistant ministers,</li>  <li> Members of parliaments or of similar legislative bodies,</li>  <li>Members of governing bodies of political parties,</li>  <li>Members of supreme courts, of constitutional courts or of other high-level judicial bodies whose decisions are not subject to further appeal, except in exceptional circumstances,</li>  <li>Members of courts of auditors or of the boards of central banks,</li> <li>Ambassadors, chargés d'affaires and high-ranking officers in the armed forces,</li>  <li>Members of administrative, management or supervisory bodies of governmental businesses or stated owned enterprises,</li> <li>Directors, deputy directors and members of the board of directors or persons holding an equivalent position in an international organization,</li> <li>Mayors</li> </ul>",
	step1_stepMsz3: 'The definition of a U.S. person (“United States person”) includes: <ul>  <li> A U.S. citizen or resident (including dual citizenship),</li> <li> A U.S. alien (resident for tax purposes)</li>  <li> A person born in the U.S? </li>   <li> A person with a current U.S. mailing or residence address (including a U.S. post office box or U.S. in care of address) </li>    <li> A person with a current U.S. telephone number </li> <li> A person with standing instructions to transfer funds to an account maintained in the United Sates?</li>  <li> A person with current and effective power of attorney or signatory authority granted to a person with U.S. address?</li> </ul>',
	//============step2
	step2_financialDetails: 'Financial Details',
	step2_txt1: 'If employed please specify',
	step2_txt2: 'Estimated Annual Income (USD)',
	step2_txt3: 'Estimated Net Worth (USD)',
	step2_txt4: 'Source Of Funds',
	step2_txt5: 'Save & Continue',
	step2_txt6: 'Employment',
	step2_txt7: 'Inheritance',
	step2_txt8: 'Investment',
	step2_txt9: 'Real Estate',
	step2_txt10: 'Savings',
	step2_txt11: 'Other',
	//============step3
	step3_Questions: 'Questions',
	step3_txt1: 'Lets test your trading experience',
	step3_txt2: 'As a regulated entity, we are required to assess whether you have appropriate understanding to trade leveraged products. Please complete your Appropriateness test carefully, as your responses will be used to determine whether you can open a Live trading account with us.',
	step3_txt3: 'Start Test',
	//============step4
	step4_readaccept: 'I have read, understood and accept the',
	step4_ClientAgreement: 'Client Agreement',
	step4_privacyplicy: 'Privacy Policy',
	step4_and: 'and',
	step4_riskDisclosr: 'Risk Disclosure documents',
	step4_termsAgreeRqd: 'Please agree to these terms',
	step4_policytwo: 'I agree for my personal data to be processed and stored as per the Privacy Policy, and for Fxview to contact me regarding important information for my account',
	step4_AfterCalling: 'Note: After clicking on',
	step4_saveContinue: 'Save & Continue',
	step4_allInfoCorrect: "you won't be able to change any previous step information. Make sure all information is correct!",

	//==========step5
	step5_browsersupport: "Maybe the browser is facing some technical issue with the webcam",
	step5_cameradenied: 'Camera permission denied',
	step5_scanqrcode: 'Scan QR code instead',
	step5_scanqrmobile: 'Scan this QR code using your mobile camera or QR code app',
	step5_keepageopen: 'Please keep this page open while you are using your mobile',
	step5_continueBrowser: 'Continue with Browser',
	step5_docSubsuccess: 'Your documents have been submitted successfully. Please be patient while we review your documents and it may take upto 24 hours or more during peak time.',
	step5_reviewstatus: 'click here to review status of your ticket',
	step5_identifyDoc: 'IDENTITY DOCUMENTS',
	step5_proofresidence: 'PROOF OF RESIDENCE DOCUMENTS',
	step5_uploadphototext: 'Upload a photo of your identity document. Please ensure that the details on the ID matches with the information you entered in the personal information form.',
	step5_uploadproof: 'Upload a proof of your residence address (in your name & not more than 6 months old). Please note that we do not accept screenshots.',
	step5_takephoto: "Take a photo of your Driver's Licence and upload it here",
	step5_takegovernid: 'Take a photo of your Government issued ID and upload it here',
	step5_goodQuality: 'Good quality:',
	step5_brightclear: 'Bright and clear',
	step5_note: 'Note:',
	step5_allcorner: 'All corners of the document to be visible and document must be valid (not expired)',
	step5_allcorner1: ' Must show your full name, residence address, issuing institution and issue date. All corners of the document to be clearly visible.',
	step5_uploadfrontside: 'Please upload the front side of your document',
	step5_maximumfilesize: 'Maximum files size of can be uploaded up to ',
	step5_maxfilesize: 'Maximum file size accepted is up to ',
	step5_uploadbackside: 'Upload the back of your document',
	step5_upload: 'Upload',
	step5_idenfNumber: 'Please mention your id number located in your identity document.',
	step5_uploadpassport: 'Take a photo of your Passport and upload it here',
	step5_photolicense: "Take a photo of your Driver's Licence and upload it here",
	step5_photogovernmentID: 'Take a photo of your Government issued ID and upload it here',
	step5_proofsixold: 'Take a photo of your proof or residence (not older than 6 months):',
	step5_bankstatement: 'Bank Statement, Utility Bill (water, electricity, home internet or landline), Tax Document, Rental Agreement (if issued in the last 6 months)',
	step5_uploadyourDoc: 'Upload your document',
	step5_idnorequired: 'ID Number is Required.',
	step5_filesizemax: 'files size can be maximum',
	step5_filesallowed: 'Only jpg, jpeg, png, pdf files are allowed! ',
	step5_uploadbothside: 'Please upload both side of your document',
	step5_verifydoc: 'Please upload your document to verify your information',
	step5_continuemobile: 'Continue with mobile',
	step5_recentphoto: 'Please upload your recent photo',
	step5_photoverif: 'PHOTO VERIFICATION',
	step5_legitimacy: 'All users are required to upload a Verification photo. This is just part of the numerous techniques and systems we employ to ensure the legitimacy of our users.',
	step5_back: 'back',
	step5_start: 'Use Webcam',
	step5_TakeSelfie: 'Take a selfie',
	step5_webcamdont: "Continue with Mobile",
	step5_captureimage: 'Capture Image',
	step5_cancel: 'Cancel',
	step5_filemax: 'files size can be maximum of',
	step5_choosefileupload: 'Choose File To upload',
	step5_allowmaxsize: 'Maximum file size we allow is of',
	step5_useWebcam: 'Use Web Cam',



	//======================social trade=====================
	//========social trade
	soclTrade_zullutrade: 'Zulu Trade',
	soclTrade_mql: 'MQL5',

	//==========zullutrade 
	zulu_trade: 'ZuluTrade',
	zulu_zulitradeinfo: 'Zulu trade is a social trading platform where you can follow traders across the globe and copy trades whilst learning from the strategies they use. Based on the Complete information available for their trading styles and performance, you can easily make the traders of your choice and once you follow them, their trades will automatically be copied in your account.',
	zulu_createAccount: 'Create Zulu Account',
	zulu_setupzulutrade: 'How to setup ZuluTrade account',
	zulu_registeropen: 'Register and open a Fxview ZuluTrade account.',
	zulu_findaccount: 'Fund the account with a minimum of $100 to receive login credentials from the ZuluTrade.',
	zulu_logintozulu: 'Login to the zulu trade website and start following any trader(s) of your choice.',

	//=========mam-pamm
	mampam_heading: 'MAM/PAMM',
	mampam_programenable: 'The fxview MAM/PAMM program enables experienced traders to manage multiple sub accounts under a single master account, in a professional manner.',
	mampam_knowmore: 'Know More',
	mampam_becameinvestor: 'How to become an investor:',
	mampam_clicktobecame: 'Click on "Become an Investor"',
	mampam_uniquepamid: 'Enter your manager’s unique PAMM ID to view his profile.',
	mampam_createinverstor: 'Create your investor account and connect with the PAMM account',
	mampam_monitoracc: 'Monitor your account through PAMM investor’s dashboard',
	mampam_connectmanager: 'Connect to a Manager',
	mampam_becomemanager: 'How to become an Manager:',
	mampam_clickbecomemanager: 'Click on “become a manager”',
	mampam_meetconditions: 'Meet the required conditions to receive your unique PAMM Id',
	mampam_manageaccount: 'Manage your account through exclusive PAMM portal',
	mampam_becomeManager: 'Become a Manager',

	//=========mam-pamm-account
	mampamm_account_tab: 'Sub Account',
	mampamm_account_account_type: 'Sub Account',
	mampamm_account_heading: 'Account IB MAMM',
	mampamm_account_description: 'The fxview MAM/PAMM program enables experienced traders to manage multiple sub accounts under a single master account, in a professional manner.',
	mampamm_account_regsiter_heading: 'Steps to register IB MAMM Account',
	mampamm_account_clicktobecame: 'Click on "Become an Investor"',
	mampamm_account_uniquepamid: 'Enter your manager’s unique PAMM ID to view his profile.',
	mampamm_account_createinverstor: 'Create your investor account and connect with the PAMM account',
	mampamm_account_monitoracc: 'Monitor your account through PAMM investor’s dashboard',
	mampamm_account_disclaimer: 'Disclaimer',
	mampamm_account_username: 'Name',
	mampamm_account_usernameRequired: 'The name is required',
	mampamm_account_signature: 'Signature',
	mampamm_account_signatureRequired: 'The signature is required',
	mampamm_account_signatureMatchError: "Signature doesn't match with username",
	mampamm_account_termscondition: 'I accept all the Terms and Conditions.',
	mampamm_account_termsconditionRequired: 'Please agree terms and conditions in order to proceed',
	mampamm_account_Proceed: 'Proceed to Create IB MAMM Account',
	mampamm_account_Cancel: 'Cancel',
	mampamm_account_Create: 'Create IB MAMM Account',
	mampamm_account_List_Header: 'MY IB MAMM Account',
	mampamm_account_Open_Ib_Mam_Pamm: 'Open IB MAMM Trading Account',
	mampamm_account_Created_Successfully: 'Your account IB MAMM has been successfully created. Your credentials are:',
	mampamm_account_Disclaimer_Approved_Successfully: 'Disclaimer approved successfully',
	mampamm_account_No_Pdf_Found: 'No pdf found',






	//===========mql5
	mql_heading: 'MQL5',
	mql_text: 'MQL5 is one of the largest copy-trading communities in the world, connecting novice traders with experienced ones. Users can choose from thousands of free and fee-liable verified signals to improve their trading performance',
	mql_createliveAcc: 'Create Live Account',
	mql_stepsRegister: 'Steps to register MQL5',
	mql_stepone: 'Register a MQL5 account on its websites',
	mql_stepTwo: 'Open Metatrader platform and go to Tools >> Options and click on the Community tab. Login into the MQL5 account and click OK.',
	mql_stepThree: 'Go to signals tab in the terminal window and select the signal that you want to follow.',


	//=======================unauthorized=============================================
	//=============unauthorized
	unaut_under: 'Under',
	unaut_Verification: 'Verification',
	unaut_pendingVerificationMsz1: 'Your application is under review by our compliance department. It may take 3-4 working days for your documents to be verified. You will receive an email once your documents are verified',


	//=============================trading accounts=======================
	//===============create zullu account
	createzullu_Your: 'Your',
	createzullu_successcreate: 'zulu account has been successfully created. Your credentials are:',
	createzullu_accountBaseCurrency: 'Account Base Currency',
	createzullu_tradenow: 'Trade Now',
	fund_now: 'Fund Now',
	createzullu_forWeb: 'For Web',
	createzullu_open: 'Open',
	createzullu_tradingAcc: 'Trading Account',
	createzullu_classic: 'Classic',
	createzullu_profitsharing: "Profit Sharing",
	createzullu_USD: 'USD',
	createzullu_EUR: 'EUR',
	createzullu_GBP: 'GBP',
	createzullu_AUD: 'AUD',
	createzullu_ZAR: 'ZAR',
	createzullu_leverageField: 'Leverage is a required field',
	createzullu_accountPassword: 'Trading Account Password',
	createzullu_passwordcontain: 'Your password must contain minimum 6 characters and maximum 15 characters and includes atleast 1 special character (!@#$%^*/)',
	createzullu_createAccount: 'Create Account',
	//=================create account
	demoacc_demomsg: 'demo account has been successfully created. Your credentials are:',
	demoacc_MT4: 'MetaTrader 4',
	demoacc_MT5: 'MetaTrader 5',
	demoacc_passwordMust: 'Your password must contain minimum 6 characters and maximum 24 characters and includes atleast 1 special character (!@#$%^*/) ',
	//==================create live account

	liveacc_accounthas: 'live account has been ',
	demoacc_accounthas: 'demo account has been ',
	liveacc_successfully: 'successfully',
	liveacc_credentialsare: 'created. Your credentials are:',


	// ============= /withdrawal =========================
	// withdrawal_wallet.vue
	wit_Wallet_from_wallet: "from wallet",
	depMsz11: 'Not the right Skrill account? Please',
	wit_Wallet_Back: "Back to wallet",
	wit_Wallet_No: "No wallet",
	wit_withdrawal: 'Withdrawals',
	wit_freeMargin: 'Free Margin',
	wit_withdrawalMsz1: "Sorry, you're not eligible for a withdrawal yet. Depositing and trading can help you become eligible!",
	wit_PrincipalWithAmount: 'Principal Withdrawal Amount',
	wit_AccNumber: 'Account Number:',
	wit_skrillId: 'Skrill ID:',
	wit_netId: 'Neteller ID:',
	wit_creditCardNumber: 'credit card number',
	wit_expiryDate: 'expiry date',
	wit_allowOption: 'Please select from the above allowed options',
	wit_WithdrawalMethodReq: 'Withdrawal Method is required',
	wit_EnterWithdrawal: 'Enter withdrawal',
	wit_requestWithdrawal: 'You can request the withdrawal from newly approved payment options after 24 hours of approval',
	wit_withdrawalMsz2: 'We have received your withdrawal request, and will update you accordingly',
	wit_withCont1: 'Fxview does not charge withdrawal fees. However, ease note that payment processors/financial intermediaries may charge a transaction fee.',
	wit_withCont2: 'Due to third party transaction restrictions, funds can only be returned to a bank account in the same name as your Fxview trading account. Furthermore, funds will only be returned to the same bank account from which they were received.',
	wit_withCont3: 'The total amount you can withdraw into your card cannot exceed the total amount deposited with the card. Amounts exceeding this level can be withdrawn into your bank account, Neteller or Skrill',

	//==========withdrawal.vue
	withdraw_backWithdraw: 'Back to Withdrawal',

	//==============withdrawal list
	withdrawList: 'Withdrawal List',
	withdrawList_all: 'All',
	withdrawList_pending: 'Pending',
	withdrawList_processed: 'Processed',
	withdrawList_rejected: 'Rejected',
	withdrawList_created: 'Date',
	withdrawList_accountId: 'Account ID/Wallet No.',
	withdrawList_amount: 'Amount',
	withdrawList_currency: 'Currency',
	withdrawList_withdrawalType: 'Withdrawal Type',
	withdrawList_method: 'Method',
	withdrawList_withdrawalStatus: 'Status',
	withdrawList_detail: 'Detail',
	withdrawList_viewTicket: 'View Ticket',

	// ============================= /wallet =========================
	// wallet.vue
	Wallet_Wallet: "Wallet",
	Wallet_Loyalty_Points: "Loyalty Points",
	// wallet_detail.vue
	Wal_detail_Add_New: "Add New Wallet Currency",
	Wal_detail_Wallet_ID: "Wallet ID",
	Wal_detail_Deposit: "Deposit",
	Wal_detail_Withdraw: "Withdraw",
	Wal_detail_Transfer: "Transfer",
	Wal_detail_curr_required: "The currency field is required",
	Wal_detail_Submit: "Submit",
	Wal_detail_Trans_History: "Transaction History",
	Wal_detail_Date: "Date",
	Wal_detail_Time: "Time",
	Wal_detail_Type: "Type",
	Wal_detail_From: "From",
	Wal_detail_To: "To",
	Wal_detail_Amount: "Amount",
	Wal_detail_Status: "Status",
	Wal_detail_availAmount: 'Available Amount:',


	// account-funding.vue
	acc_fund_Deposit: "Deposit",
	acc_fund_Withdrawal: "Withdrawal",
	// change_wallet_currency.vue
	chang_wal_curr_Internal_Transf: "Wallet Internal Transfer",
	chang_wal_curr_Transf_Wall_amount: "Transfer Wallet amount",
	chang_wal_curr_Back: "Back to Wallet",

	// loyalty-points.vue
	loyalP_Reward_Points: "Loyalty Reward Points",
	loyalP_Know_More: "Know More",
	loyalP_Trans_Wallet: "Transfer to Wallet",
	// =======================/wallet/loyality===========================
	// loyality_point_transfer.vue
	loyalP_Transfer: "Transfer",
	loyalP_transf_TotalP: "Total loyalty points",
	loyalP_transf_Amou_Avail: "Amount Available",
	loyalP_transf_Enter_p_transfe: "Enter point to transfer",
	loyalP_transf_Cancel: "Cancel",
	loyalP_transf_Transfer: "Transfer",
	loyalP_transf_Back: "Back to Wallet",
	loyalP_transToAcc: 'Transfer To Wallet ID',
	loyalP_fieldReq: 'Field is required',
	loyalP_fieldReq_min: 'Minimum redeemable loyalty points = 100 loyalty points',
	loyalP_intTransMsz2: 'Please click on the link to confirm your internal transfer',
	loyalP_intTransMsz3: 'The transfer has been completed successfully',
	loyalP_fromTradId: 'From Trading ID',
	loyalP_toTradId: 'To Trading ID',
	loyalP_transferAmount: 'Transferred Amount',
	// loyality_card_detail.vue
	loyal_card_det_You_are_a: "You are a",
	loyal_card_det_member: "member",
	loyal_card_det_Points: "Points",
	loyal_card_det_Last_Credit_On: "Last Credit On",
	loyal_card_det_Points: "Points",
	loyal_card_det_Earn: "Earn",
	loyal_card_det_more_points_to_jump_to: "more points to jump to",
	loyal_card_det_gain_add_benefi: "to gain additional benefits",
	// loyality_txn_list.vue
	loyal_List_Trans_History: "Transaction History",
	loyal_List_Date: "Date",
	loyal_List_Activity: "Activity",
	loyal_List_Volume: "Volume",
	loyal_List_Points: "Points",
	loyal_List_Cr_Db: "Cr/Db",
	// loyalty-verify.vue
	loyal_ver_back: "Back to Wallet",
	// redeam-point.vue
	redeamP_your_points: "Redeem your loyalty points",
	redeamP_Points: "Points",
	redeamP_Redeem: "Redeem",
	redeamP_Red_Points: "Redeem Points",
	redeamP_Points: "Points",
	redeamP_Now: "Redeem Now",
	redeamP_walletpoints: 'Please Redeem Wallet Points as per following details <br> points : ',
	redeamP_pointdesc: '<br> point_desc :',




	// ==========================tool-pages====================
	//========tools.vue
	tool_overview: 'Overview',
	tool_autochartistScan: 'AutoChartist Scanner',
	tool_autochartistWeb: 'AutoChartist Web',
	tool_Vpsheading: 'VPS',
	tool_ecoCalendar: 'Economic Calendar',
	tool_tradingToolbox: "Trader's Tool Box",
	tool_Calculator: 'Calculators',
	tool_tradingHOur: 'Trading Hours',
	tool_Signal: 'Signals',
	// autochartist_scanner.vue
	autoScan_knoMore: "Know more",
	autoScan_DownLive: "Download for Live Account",
	autoScan_HowInstall: "How to install AutoChartist",
	autoScan_usrGuide: "user guide",
	autoScan_goTool: "In the platform, go to tools > options > expert advisors to allow DLL imports and click on OK.",
	// vps.vue
	toolVps_sureImp: "Are you sure to implement this operation?",
	toolVps_confirm: "confirm",
	toolVps_cancel: "cancel",
	toolVps_Shut_Down: "Shut-Down",
	toolVps_Restart: "Restart",
	toolVps_Reboot: "Reboot",
	toolVps_Change_Pass: "Change-Password",
	toolVps_VieDet: "View Detail",
	toolVps_UpdAcc: "Update Account",
	toolVps_Unsubscribe: "Unsubscribe",
	toolVps_vpsList: "Virtual  Private <span>Server</span>(VPS) List",
	toolVps_createVps: "Create VPS",
	toolVps_SubList: "Subscription List",
	toolVps_accWalt: "Account/Wallet",
	toolVps_Priodicity: "Priodicity",
	toolVps_Price: "Price",
	toolVps_strtDate: "Start Date",
	toolVps_endDate: "End Date",
	toolVps_Action: "Action",
	toolVps_vps: "Virtual  Private <span>Server</span>(VPS)",
	toolVps_vpsTilte: "Enjoy an unparalleled trading experience with us, where the stability of your trades is assured. There is no need to worry about latency or deal with multiple software on your system any more. Use our FREE VPS to get lightning fast responses to your trades and enjoy impressive speeds on our platforms.",
	toolVps_redLate: "Reduced Latency",
	toolVps_freeOn5000: "Free with a deposit of $5,000 or more",
	toolVps_remoteAccess: "Remote Access",
	toolVpsstab_Env: "Stable Environment",
	toolVps_back_vpsList: "Back to VPS List",
	toolVps_tc: "Terms and Conditions Apply",
	toolVps_Plan: 'Plan',
	toolVps_Status: 'Status',
	toolVps_type: 'Type',
	toolVps_nextpayment: 'Next Payment',
	toolVps_passWordMustContain12: 'Your password must contain at least 12 characters, and include at least 1 number, 1 uppercase character and 1 special character (!@#$%^&*/)',


	// sub_change_account_verify.vue
	toolVps_verifySubscribe: "Your update trading account request has been processed successfully",
	toolVps_back_subList: "Back to Subscription List",
	toolVps_reqProcessing: 'request processing...',
	toolVps_reqVerify: 'Request Verification',
	toolVps_reqFailed: 'Request Failed',

	// sub_change_account.vue
	VpsSub_1_Record: "You only have one record. Please create at least one more trading account or wallet before attempting an change subscription account.",
	VpsSub_liveAcc: "Live Account",
	VpsSub_Wallet: "Wallet",
	VpsSub_ChangeTradAcc: "Change Subscription Trading Account",
	VpsSub_back_subLis: "Back to Subscription List",
	VpsSub_Submit: "Submit",
	VpsSub_received_request: "We have received your chnage trading account request, and will update you accordingly",
	VpsSub_withdrawalAuthMessage: 'Kindly verify the withdrawal request by clicking on the link that we sent to your registered email ID',
	VpsSub_noTradingAccFound: 'No Live Trading Account Found!',


	// unsubscribe_plan.vue
	VpsUnSub_1_record: "You  only have  one record. Please create at least one more trading account or wallet before attempting an change subscription account.",
	VpsUnSub_liveAcc: "Live Account",
	VpsUnSub_Wallet: "Wallet",
	VpsUnSub_sureUnsub: "Are you sure to unsubscribe",
	VpsUnSub_plan_: "plan?",
	VpsUnSub_confirm: "confirm",
	VpsUnSub_Cancel: "Cancel",
	VpsUnSub_received_request: "We have received your chnage trading account request, and will update you accordingly",
	VpsUnSub_back_subList: "Back to Subscription List",
	// unsubscribe_verify.vue
	VpsUnSubVer_successfully: "Your unsubscribe plan request has been processed successfully",
	VpsUnSubVer_back_subList: "Back to Subscription List",
	// market_trading_hours.vue
	marktTrdHour_title: "Market Trading Hours",
	marktTrdHour_txt: "Our server time is GMT+3 during US Daylight Savings Time (DST) and GMT+2 during US Non Daylight Savings Time (Non-DST).",
	marktTrdHour_table_below: "The table below lists the opening and closing hours of various instruments and asset classes as per our server time.",
	marktTrdHour_Forex: "Forex",
	marktTrdHour_Indices: "Indices",
	marktTrdHour_Commodities: "Commodities",
	marktTrdHour_Open: "Open",
	marktTrdHour_Close: "Close",
	marktTrdHour_Break: "Break",
	// traders_marketplace.vue
	trdMarktPlac_title: "Trader's <span>Market Place</span>",
	trdMarktPlac_txt: "Browse our marketplace to access strategies created by some of the world's best traders, or design your own and we'll help you get it built.  Our marketplace is a one stop shop to take your trading to the next level.",
	trdMarktPlac_Automate: "Automate your <span>trading</span> to get the most out of the markets",
	trdMarktPlac_Customise: "Customise your trading",
	trdMarktPlac_Customise_Txt: "Define your requirements and bring your system to life by connecting with a developer who will build it for you",
	trdMarktPlac_Risk_manag: "Risk management",
	trdMarktPlac_Risk_manag_txt: "Review the performance of signal providers based on their experience, best & worst trades, risk profile and more",
	trdMarktPlac_Browse_library: "Browse our library",
	trdMarktPlac_Browse_libraryTxt: "Browse our extensive library of EAs and indicators for MT4, MT5 and ActTrader, and find the right fit for your needs",
	trdMarktPlac_Categories: "Categories",
	trdMarktPlac_All: "All",
	trdMarktPlac_Expert: "Expert",
	trdMarktPlac_Advisors: "Advisors",
	trdMarktPlac_Indicators: "Indicators",
	trdMarktPlac_ActTrader: "ActTrader",
	trdMarktPlac_Popular: "Popular",
	trdMarktPlac_New: "New",
	trdMarktPlac_Free: "Free",
	trdMarktPlac_Paid: "Paid",
	trdMarktPlac_Long_Str: "Long Term Strategies",
	trdMarktPlac_2frame: "Two Frames",
	trdMarktPlac_StratCon2: "Strategy consists of two different charts history:",
	trdMarktPlac_Details: "Details",
	trdMarktPlac_Add_List: "Add To List",
	trdMarktPlac_Hammer_Ass: "Hammer Assistant",
	trdMarktPlac_Strat_trad_assis: "This Strategy (trading assistant) will warn you when a hammer is forming and",
	trdMarktPlac_Pos_Mgmt: "Positions Management",
	trdMarktPlac_Lot_Cal: "Lot Calculator",
	trdMarktPlac_Lot_Cal_txt: "Lot Calculator - is a Forex tool that lets you calculate the size of the ...",
	trdMarktPlac_Short_Strat: "Short Term Strategies",
	trdMarktPlac_Reg_Stra: "Regression Strategy",
	trdMarktPlac_Reg_StraTxt: "Strategy opens a buy position when low value of current candle is = top belt ..",
	trdMarktPlac_NoData: "No Data",
	// economic_calendar.vue
	ecoCalendar: "Economic Calendar",
	ecoCal_Title_Txt: "Track important economic events and releases that impact Forex, Commodities and Indices.",
	ecoCal_Up_next: "Up next",
	ecoCal_Country: "Country",
	ecoCal_Select_All: "Select All",
	ecoCal_Clear: "Clear",
	ecoCal_My_Filter: "My Filter",
	ecoCal_Default: "Default",
	ecoCal_Impact: "Impact",
	ecoCal_All: "All",
	ecoCal_Medium: "Medium",
	ecoCal_High: "High",
	ecoCal_Save_filter: "Save setting in my filter",
	ecoCal_Apply_Filter: "Apply Filter",
	ecoCal_Apply_Filter: "Apply Filter",
	ecoCal_Time: "Time",
	ecoCal_TimeZ_Settings: "Time Zone Settings",
	ecoCal_TimeZ: "Time Zone",
	ecoCal_Select_TimeZ: "Select Time Zone",
	ecoCal_TimeF: "Time Format",
	ecoCal_Set_timeZ_Auto: "Set my time zone automatically",
	ecoCal_Save_Sett: "Save Setting",
	ecoCal_Cancel: "Cancel",
	ecoCal_Impact: "Impact",
	ecoCal_noRecord: "No Record",
	ecoCal_Country: 'Country',
	ecoCal_Event: 'Event',
	ecoCal_Actual: 'Actual',
	ecoCal_Forecast: 'Forecast',
	ecoCal_Previous: 'Previous',


	// trading_tool.vue
	tools_Trad_Tools: "Trading Tools",
	tools_Trad_Tools_Txt: "Make informed and timely investment decisions using our powerful trading tools that help you identify potential opportunities and build a stronger trading strategy",
	tools_Auto_Scanner: "AutoChartist Scanner",
	tools_Auto_Scanner_txt: "Never miss a trading opportunity again..",
	tools_VPS: "VPS",
	tools_VPS_txt: "Enjoy free basic VPS or choose from subscription..",
	tools_Eco_Calendar: "Economic Calendar",
	tools_Eco_Calendar_txt: "Stay up to date on important economic events..",
	tools_Trad_Toolbox: "Trader's Toolbox",
	tools_Trad_Toolbox_txt: "A premium range of trading and analysis tools..",
	tools_Calculators: "Calculators",
	tools_Calculators_txt: "Calculate pip value, margin, swaps & more..",
	tools_TradeMarket: "Trader's Marketplace",
	tools_TradeMarket_txt: "Find your ideal EA or indicator, or have..",
	tools_Trad_Hours: "Trading Hours",
	tools_Trad_Hours_txt: "Quickly see when the markets are open..",
	tools_Auto_Idea: "AutoChartist Idea",
	tools_Auto_Idea_txt: "Never miss a trading opportunity again..",
	tools_readmore: 'Read More',
	tools_downloa: 'download for',
	MT4Demo: 'MT4 Demo',
	MT5Demo: 'MT5 Demo',
	toolor: 'or',
	toolknowMore: 'know More',

	//==================shared=====================================
	//=============change-entity 

	chEn_entity: 'Entity',
	chEn_global: 'Fxview Global',
	chEn_europe: 'Fxview Europe',
	chEn_redirectmsg1: 'Based on your residence country selection, you will be redirected to the website of Charlgate Ltd., which is registered in Cyprus. Charlgate Ltd. falls under the European regulatory framework, and is in scope of the Markets in Financial Instrument Directive II (MiFID II), among others. In addition, there is provision for an investor compensation scheme.',
	chEn_redirectmsg2: '',
	chEn_continue: 'Continue',
	chEn_takeback: 'Take me back',

	//===========advanced chart

	adchart_create: 'Create',
	adchart_save: 'Save',
	adchart_chart: 'Chart',
	adchart_Studies: 'Studies',
	adchart_failedchart: 'Failed to load chart',
	adchart_kindlyrefresh: 'Kindly refresh',

	//=========chart
	chart_loadchartfail: 'Failed to load chart Kindly refresh!',

	//=========filter component
	filter_Selecttimezone: 'Select Timezone',
	filter_Low: 'Low',
	filter_medium: 'Medium',
	filter_high: 'High',
	filter_submit: 'Submit',
	//================header
	head_Wallet: 'Wallet',
	head_loyality: 'Loyality Points',
	head_createLiveAcc: 'Create Live Account',
	head_createDemoAcc: 'Create Demo Account',
	head_Notification: 'Notification',
	head_seeAll: 'See All',
	head_noNewNotification: 'No New Notifications',
	head_verified: 'Verified',
	head_deposit_enabled: 'Deposit Enabled',
	head_notVerified: 'Not Verified',
	head_profile: 'Profile',
	head_changePassword: 'Change Password',
	successMsz4: "Password Changed Successfully",
	head_security: 'Security',
	head_referFriend: 'Refer a friend',
	head_logout: 'Log out',
	//=========leftnavbar
	leftnav_dashboard: 'Dashboard',
	leftnav_wallet: 'Wallet',
	leftnav_accfunding: 'Account Funding',
	leftnav_manageAcc: 'Manage Account',
	leftnav_Depositbonus: 'Deposit Bonus',
	leftnav_socialTrade: 'Social Trading',
	leftnav_tools: 'Tools',
	leftnav_education: 'Education &',
	leftnav_resources: 'Resources',
	leftnav_downloadplatform: 'Download Platform',
	leftnav_support: 'Support',
	//==============loader 
	load_norecordfound: 'No records found',
	//==============no trading account
	tradAcc_application: 'Please complete your account application and create a',
	tradAcc_application1: 'Please complete your account application to access this function',
	tradAcc_trading: 'trading',
	tradAcc_live: 'live',
	tradAcc_accountAccess: 'account to access this function.',
	tradAcc_resumeApplication: 'Resume Application',
	tradAcc_checkappStatus: 'Your application is under review, Please check the status of your application.',
	tradAcc_ticket: 'Ticket',
	tradAcc_createliveAcc: 'Please create a live account to access this function',
	tradAcc_liveDemoAcc: 'Please create a live or demo account to access this function',
	tradAcc_demoAcc: 'Demo Account',
	tradAcc_createWallet: 'Please create a wallet  to access this function',
	tradAcc_wallet: 'Wallet',
	//===========pagination
	pagin_totalRecords: 'Total Records',
	//==========shared/tradingAccounts===================
	//===========account list table
	acclist_fund: 'Fund',
	acclist_addFund: 'Add Funds',
	acclist_addFundTo: 'Add Funds to',
	acclist_tradingId: 'Trading ID',
	acclist_addingFundTo: 'Adding Funds to',
	acclist_fund_msz: 'deposit successful ',
	acclist_fund_mszErr: 'deposit unsuccessful',
	acclist_changeLeverage: 'Change Leverage',
	acclist_changePassword: 'Change Password',
	acclist_internalTransfer: 'Internal Transfer',
	acclist_tradeNow: 'Trade Now',
	acclist_detachAcc: 'Detach account',
	//=============account-id 
	accId_TransFromAccId: 'Transfer from account id',
	accId_selectAccountId: 'select account id',
	accId_fieldReq: 'Field is required',
	//============close trading listing
	closetrad_login: 'Login',
	closetrad_order: 'Order',
	closetrad_symbol: 'Symbol',
	closetrad_volume: 'Volume',
	closetrad_openPrice: 'Open Price',
	closetrad_openTime: 'Open Time',
	closetrad_commision: 'Commission',
	closetrad_type: 'Type',
	closetrad_SL: 'SL',
	closetrad_TP: 'TP',
	closetrad_closePrice: 'Close Price',
	closetrad_closeTime: 'Close Time',
	closetrad_Swap: 'Swap',
	closetrad_PNL: 'PNL',
	closetrad_comment: 'Comment',
	closetrad_price: 'Price',
	//================open close trade list 
	OCtradelist_balance: 'Balance',
	OCtradelist_margin: 'Margin',
	OCtradelist_equity: 'Equity',
	OCtradelist_pnl: 'PNL',
	OCtradelist_tradeNow: 'Trade Now',
	OCtradelist_opentrade: 'Open Trade',
	OCtradelist_closetrade: 'Close Trade',
	//===============open order listing
	openOrder_orderId: 'Order ID',
	openOrder_accountId: 'Account ID',
	openOrder_quantity: 'Quantity',
	openOrder_triggered: 'Triggered',
	openOrder_side: 'Side',
	openOrder_tradeId: 'Trade ID',
	openOrder_profit: 'Profit',
	openOrder_agentComm: 'Agent Commission',
	openOrder_cmd: 'Cmd',
	openOrder_sl: 'SL',
	openOrder_tp: 'TP',
	openOrder_swaps: 'Swaps',
	// trading_calculators.vue
	trade_cal_title: "Trading Calculators",
	trade_cal_title_Txt: "Our online calculators provide you with an easy way to analyse the trades that you plan to make. We help you calculate values based on market conditions and provide you with instant results.",
	trade_cal_Commission: "Commission",
	trade_cal_Multi_Target: "Multi-Target",
	trade_cal_Pivot_Points: "Pivot Points",
	trade_cal_Profit_Loss: "Profit & Loss",
	trade_cal_Fibonacci: "Fibonacci",
	trade_cal_Pip_Value: "Pip Value",
	trade_cal_Swap: "Swap",
	trade_cal_Position_Size: "Position Size",
	trade_cal_Currency_Convertor: "Currency Convertor",
	// ====================/shared/calculators============================
	// Commission.vue
	cal_comm_title: "Commission",
	cal_comm_title_txt: "Calculate the commissions you would pay for a trade with our commission calculator. Fxview charges a commission of $1/100,000 each way (or $2/100,000 round-trip). Our commission calculator will assist you in calculating how much this works out to, for any given trade. Simply enter the asset class, symbol, account base currency and the trade size, and press 'Calculate Now.'",
	cal_comm_forex: "forex",
	cal_comm_commodities: "commodities",
	cal_comm_indices: "indices",
	cal_comm_Asset_Class: "Asset Class",
	cal_comm_Field_req: "field is required",
	cal_comm_USD: "USD",
	cal_comm_GBP: "GBP",
	cal_comm_AUD: "AUD",
	cal_comm_EUR: "EUR",
	cal_comm_accBaseCurr: "Account Base Currency",
	cal_comm_Symbol: "Symbol",
	cal_comm_trade_size_lot: "Trade Size (in lots)",
	cal_comm_now: "Calculate Now",
	cal_comm_Comm_roundT: "Commission (round trip)",
	// Margin.vue
	cal_marg_title: "Margin",
	cal_marg_title_txt: "The Margin Calculator helps you determine the margin required to open a position. Simply select the asset class, symbol, account currency and the trade size to ascertain the margin required based depending on the maximum leverage offered for different types of instruments.",
	cal_marg_Field_req: "field is required",
	cal_marg_accBaseCurr: "Account Base Currency",
	cal_marg_Symbol: "Symbol",
	cal_marg_trade_size_lot: "Trade Size (in lots)",
	cal_marg_now: "Calculate Now",
	cal_marg_req: "Margin Require",
	cal_marg_max_lev: "Max. Leverage",
	cal_marg_forex: 'forex',
	cal_marg_commodities: 'Commodities',
	cal_marg_indices: 'Indices',
	// milti_Target.vue
	cal_milti_Target: "Multi Target",
	cal_milti_Target_txt: "This calculator helps traders to plan what part of their positions should be closed at certain target levels to gain the best return to risk ratio possible.",
	cal_milti_Field_req: "field is required",
	cal_milti_accBaseCurr: "Account Base Currency",
	cal_milti_Symbol: "Symbol",
	cal_milti_Position_Type: "Position Type",
	cal_milti_Buy: "Buy",
	cal_milti_Sell: "Sell",
	cal_milti_Open_Price: "Open Price",
	cal_milti_Stop_loss_Price: "Stop loss Price",
	cal_milti_trade_size_lot: "Trade Size (in lots)",
	cal_milti_Target_Price: "Target Price",
	cal_milti_lots_Clos_Target: "lots Closed At Target",
	cal_milti_Net_Lot_size: "Net Lot size:",
	cal_milti_Now: "Calculate Now",
	cal_milti_Target_Profit: "Target Profit",
	cal_milti_Total_Profit: "Total Profit",
	cal_milti_Return_Risk: "Return To Risk",
	// pivot_points.vue
	cal_pivot_point_txt: "Fxview offers a pivot points calculator to help you identify the direction of prevailing trends and determine support and resistance levels.",
	cal_pivot_High: "High",
	cal_pivot_Low: "Low",
	cal_pivot_Open: "Open",
	cal_pivot_Close: "Close",
	cal_pivot_Calculate_Now: "Calculate Now",
	cal_pivot_Clear: "Clear",
	cal_pivot_CLASSIC: "CLASSIC",
	cal_pivot_WOODIE: "WOODIE'S",
	cal_pivot_CAMARILLA: "CAMARILLA",
	cal_pivot_DMARKS: "DMARKS'S",
	cal_pivot_Resistance: "Resistance",
	cal_pivot_Pivot_Points: "Pivot Points",
	cal_pivot_Support: "Support",
	cal_pivot_Field_req: "field is required",
	cal_pivot_PivotPoints: 'Pivot Points',
	// profit_Loss.vue
	cal_profit_Loss: "Profit & Loss",
	cal_profitL_Txt: "Fxview’s profit and loss calculator is a basic tool that can assist you to calculate the profit or loss from a trade. Simply select the asset class, symbol, account base currency, the desired opening and closing prices, the position type and the trade size in lots, and press 'Calculate Now.'",
	cal_profitLField_req: "field is required",
	cal_profitL_accBaseCurr: "Account Base Currency",
	cal_profitL_Symbol: "Symbol",
	cal_profitL_Pos_Type: "Position Type",
	cal_profitL_Buy: "Buy",
	cal_profitL_Sell: "Sell",
	cal_profitL_Open_Price: "Open Price",
	cal_profitL_Close_Price: "Close Price",
	cal_profitL_trade_size_lot: "Trade Size (in lots)",
	cal_profitL_Now: "Calculate Now",
	// fibonacci.vue
	cal_Fibonacci: "Fibonacci",
	cal_fibo_txt: "With fxview’s fibonacci calculator, you can calculate fibonacci retracements based on the extreme points of a chart in an uptrend or a downtrend. Just put the high and the low values to get started.",
	cal_fibo_Uptrend: "Uptrend",
	cal_fibo_Downtrend: "Downtrend",
	cal_fibo_Field_req: "field is required",
	cal_fibo_High: "High",
	cal_fibo_Low: "Low",
	cal_fibo_Now: "Calculate Now",
	cal_fibo_Retracements: "Retracements",
	cal_fibo_Support: "Support",
	// Pip_Value.vue
	cal_Pip_Value: "Pip Value",
	cal_Pip_txt: "An effective tool for managing your risk strategy, our pip value calculator lets you calculate the value per pip of each position. With this tool you can monitor your risk for each trade with more precision.",
	cal_Pip_Field_req: "field is required",
	cal_Pip_accBaseCurr: "Account Base Currency",
	cal_Pip_Symbol: "Symbol",
	cal_Pip_trade_size_lot: "Trade Size (in lots)",
	cal_Pip_Now: "Calculate Now",
	// Swap.vue
	cal_swap: "Swap",
	cal_swap_txt: "Swaps can be thought of as the financing cost of keeping a position open. They can be either positive or negative, are paid/received when a position is kept open overnight. They are different for long and short positions, and vary across different instruments.",
	cal_swap_MT4_MT5: "MT4/MT5",
	cal_swap_ACT: "ACT",
	cal_swap_Field_req: "field is required",
	cal_swap_accBaseCurr: "Account Base Currency",
	cal_swap_Symbol: "Symbol",
	cal_swap_Num_Days: "Number of Days",
	cal_swap_trade_size_lot: "Trade Size (in lots)",
	cal_swap_Swap_Long: ">Swap Long",
	cal_swap_Swap_Short: "Swap Short",
	// position_size.vue
	cal_Position_Size: "Position Size",
	cal_position_txt: "Fxview’s position size calculator helps you calculate how many lots of a position you can open, given a pre-determined amount you are willing to risk losing. Simply specify the asset class, account base currency, symbol, position type, open price & stop loss, account balance, and the risk percentage (i.e. the percentage of your account balance you are willing to risk losing), then press 'Calculate Now.'",
	cal_position_Field_req: "field is required",
	cal_position_accBaseCurr: "Account Base Currency",
	cal_position_Symbol: "Symbol",
	cal_position_Position_Type: "Position Type",
	cal_position_BUY: "BUY",
	cal_position_SELL: "SELL",
	cal_position_Open_Price: "Open Price",
	cal_position_Account_Balance: "Account Balance",
	cal_position_Stop_Loss: "Stop Loss",
	cal_position_Risk_Perc: "Risk Percentage",
	cal_position_trade_size_lot: "Trade Size in Lots",
	cal_position_trade_size_lot: "Trade Size in Lots",
	cal_position_Now: "Calculate Now",
	// currency_convertor.vue
	cal_curr_Convertor: "Currency Convertor",
	cal_curr_conv_txt: "Fxview’s currency converter allows users to check the value of one currency against others based on current exchange rates. With our currency converter, you can convert any two currencies with just a few clicks.",
	cal_curr_conv_From: "Currency From",
	cal_curr_conv_To: "Currency To",
	cal_curr_conv_Amount: "Amount",
	cal_curr_conv_Field_req: "field is required",
	cal_curr_conv_Now: "Calculate Now",
	cal_curr_conv_Converted: "Converted Currency",
	// left-menu .vue
	cal_leftmenu_commision: 'Commission',
	cal_leftmenu_margin: 'Margin',
	cal_leftmenu_multiTarget: 'Multi-Target',
	cal_leftmenu_pivotpoints: 'Pivot Points',
	cal_leftmenu_profitloss: 'Profit & Loss',
	cal_leftmenu_fibonacci: 'Fibonacci',
	cal_leftmenu_pipValue: 'Pip Value',
	cal_leftmenu_Swap: 'Swap',
	cal_leftmenu_positionSize: 'Position Size',
	cal_leftmenu_currencyConv: 'Currency Convertor',
	//============================support folder================================================
	//============index
	suppIndex_requestServices: 'Support',
	suppIndex_OpenRequests: 'Open Tickets',
	suppIndex_ClosedRequests: 'Closed Tickets',
	//=============request-services
	suppReqService_support: 'Support',
	suppReqService_howassist: 'How can we assist you?',
	suppReqService_emailus: 'Email Us',
	suppReqService_email: 'info@fxview.com',
	suppReqService_liveChat: 'Live Chat',
	suppReqService_avail24: 'Available 24/5',
	suppReqService_requestcallback: 'Request Call Back',
	suppReqService_office: 'Office: +442031505221',
	suppReqService_support_phn: 'Support: +442031505221',
	suppReqService_createTicket: 'Create a Support Ticket',
	suppReqService_helpSupport: 'How can we help?',
	suppReqService_back: 'Back',
	suppReqService_AddPaymentMethod: 'Add Payment Method',
	ZULU: 'ZULU',
	MQL5: 'MQL5',
	depositBonus: 'Deposit Bonus',
	referfriend: 'Refer a Friend',
	supp_Wallet: 'Wallet',
	contactReq: 'The contact time is required.',
	//==============support
	support_ticketNumber: 'Ticket Number',
	support_reason: 'Reason',
	support_created: 'Date',
	support_action: 'Action',
	//===============view
	suppview_backToTicket: 'Support Home',
	suppview_thankyou: 'Thank you for verifying your identity, and welcome to Fxview! You can now open a Live trading account and start trading.',
	suppview_createliveAcc: 'create live account',
	suppview_whilevalidate1: 'While validating your proof of address document, we noticed that the address and ID number entered during registration does not match the document uploaded during verification.',
	suppview_whilevalidate2: 'While validating your proof of address document, we noticed that the address entered during registration does not match the document uploaded during verification.',
	suppview_whilevalidate3: 'While validating your proof of address document, we noticed that the ID number entered during registration does not match the document uploaded during verification.',
	suppview_originalAdress: 'Original address',
	suppview_stepMsz18: "I don't want to change anything",
	suppview_preQues: 'Previous Question',
	suppview_nextQues: 'Next Question',
	suppview_stepMsz21: 'Resolve conflict',
	suppview_idNumEnt: 'ID number entered',
	suppview_percentComplete: '% Complete',
	suppview_nationalityEntered: 'Nationality entered',
	suppview_fillone: 'Please fill atleast one field',

	//========================services folder======================
	//==================otp verification

	otpVerif_otpVerification: 'OTP Verification',
	otpVerif_otpVerificationText1: 'A One Time Pin has been sent to your email.',
	otpVerif_resendOtpTicket: "Haven't received an email in your inbox or spam folder? Resend",
	otpVerif_back: 'back',
	otpVerif_backToTicket: 'Support Home',

	//====================profile-request
	profileReq_getHelpWith: 'Get Help With',
	profileReq_Queries: 'Related Queries',
	profileReq_relatedTopics: 'Related Topics',
	profileReq_inversterPass: 'In case if you face any issues setting investor password from your MT4/MT5 platform, Please proceed with creating the support request',
	profileReq_notSatisfied: "I'm not satisfied",
	profileReq_lodgeComplaint: 'Submit a complaint',
	profileReq_helpUsWithYour: 'Help us with your',
	profileReq_askOtherQuestions: 'Ask us any other question',
	profileReq_AddBankDetails: 'Add Bank Details',
	profileReq_AddSkrillDetails: 'Add Skrill Id Details',
	profileReq_AddNetellerDetails: 'Add Neteller Id Details',
	profileReq_AddCreditCardDetails: 'Add Credit Card Details',
	profileReq_inn: 'in',
	profileReq_emailHeading: 'Please Enter your new email ID below',
	profileReq_exsistsEmailAddress: 'Existing Email Address',
	profileReq_newEmail: 'Enter Your New Email Address',
	profileReq_EmailfieldValid: 'Please enter a valid email address',
	profileReq_EmailfieldReq: 'Email field is required',
	profileReq_changeEmailAddress: 'Change Email Address',
	profileReq_mobileHeading: 'Please Enter Your New Mobile Number Below',
	profileReq_existingMobileNumber: 'Existing Mobile Number',
	profileReq_InvalidNumber: 'Invalid Number',
	profileReq_changeMobileNumber: 'Change Mobile Number',
	profileReq_postCodeRequired: 'The post code is required',
	profileReq_residenceCountryRequired: 'The residence country is required',
	profileReq_uploadRecentAddressProof: 'Upload recent address proof ',
	profileReq_docReq: 'document is required',
	profileReq_changeAddress: 'Change Address',
	profileReq_bankName: 'Bank Name:',
	profileReq_AccountName: 'Account Name',
	profileReq_bankNameRequired: 'The bank name is required',
	profileReq_accountHolderRequired: 'The account holder name is required',
	profileReq_AccNumber: 'Account Number:',
	profileReq_accountNumberRequired: 'The account number is required',
	profileReq_country: 'Country',
	profileReq_countryFieldRequired: 'The country field is required',
	profileReq_IBAN: 'IBAN',
	profileReq_ibanRequired: 'The iban is required',
	profileReq_MyBankNotIBAN: 'My Bank Doesn’t issue IBAN',
	profileReq_SwiftCode: 'Swift/BIC/Sort Code',
	profileReq_swiftCodeRequired: 'The swift code is required',
	profileReq_bankAdd: 'Bank Address:',
	profileReq_bankAddressRequired: 'The bank address is required',
	profileReq_UpBankStatement: 'Upload Bank Statement',
	profileReq_fileallow: 'Only jpg, jpeg, png, pdf, docx, doc, xls, xlsx files are allowed!',
	profileReq_addNewBank: 'Add a New Bank Account',
	profileReq_last4Digit: 'last 4 digits is required and contains only numeric character',
	profileReq_first4Digit: 'first 4 digits is required and contains only numeric character',
	profileReq_frontBack: 'We require the following for the card verification -',
	profileReq_frontPhotoCredit: 'Color copy of the front side of the card, showing: full name, expiration date, Bank name/logo, first 4 and last 4 digits of the credit card number hiding the middle 8 digits.',
	profileReq_uploadSupportingDocument: 'Upload a Supporting Document',
	profileReq_backPhotoCredit: 'Color copy of the back side of the card hiding the CVV security code. The back copy should shown the sign of the holder',
	profileReq_submit: 'Submit',
	profileReq_paymentRequiredNumeric: 'The payment id field is required and may only contain numeric characters.',
	profileReq_netSkrill1: 'please upload the screenshot of the',
	profileReq_netSkrill2: 'profile contacting the full name,',
	profileReq_netSkrill3: 'id and address. We are going to match the name and address',
	profileReq_userDetails: 'User Details',
	profileReq_ComplaintDetails: 'Complaint Details',
	profileReq_employeeWhoOffered: 'Employee who offered the services to the Client:',
	profileReq_timeDisputed: 'Date and Time of the disputed situation (in MetaTrader server time):',
	profileReq_TheDisputeTime: 'The dispute time is required',
	profileReq_ticNoContested: 'Ticket Number(s) of all contested positions and/or pending orders:',
	profileReq_DisputedAmount: 'Disputed amount:',
	profileReq_reportComplaint: 'Have you reported your complaint to any Supervisory Authority?',
	profileReq_stateNameAuth: 'Please state the name of the Supervisory Authority',
	profileReq_TheAuthorityName: 'The authority name is required',
	profileReq_DetailedDescript: 'Detailed description of the Complaint:',
	profileReq_attachTogetherForm: "Please attach together with this form any supporting evidence to your claim that will facilitate fxview's investigation of your complaint. Supporting evidence may consist of any documentation (screenshots, chats, phone records etc) relevant to the complaint.",
	profileReq_Subject: 'Subject',
	profileReq_yourMsz: 'Your Message',
	profileReq_ticketHasbeenComplaint: 'Your complaint has been Registered successfully',
	profileReq_ticketHasbeenCreated: 'Your ticket has been created',
	profileReq_proMsz19: 'Go to Tickets',
	profileReq_entervalidcard: 'please enter valid card number',
	profileReq_changeEmail: 'Please Change my email as per following details <br> Old Email :',
	profileReq_NEWEmail: '<br> New Email :',
	profileReq_changeMobile: 'Please Change my Mobile Number as per following details <br> Old Number : ',
	profileReq_newNumber: '<br> New Number :',
	profileReq_changebankinfo: 'Please Change my Bank Information as per following details <br> Account Number :',
	profileReq_holdername: '<br> Holder Name :',
	profileReq_bankname: '<br> Bank Name : ',
	profileReq_bankcode: '<br> Bank Code :',
	profileReq_sortcode: '<br> Sort Code :',
	profileReq_bankAddress: '<br> Bank Address :',
	profileReq_changeadress: 'Please Change my Address as per following details <br> Address1 : ',
	profileReq_adresstwo: '<br> Address2 :',
	profileReq_postcode: '<br> Post Code :',
	profileReq_residenceCountry: '<br> Residence Country :',
	profileReq_nation: '<br> Nationality : ',
	profileReq_City: '<br> City :',
	profileReq_pleaseAdd: 'Please Add',
	profileReq_paymentmethod: 'Payment Method per following details <br>',
	profileReq_number: 'Number :',
	profileReq_expiryDate: '<br> Expiry Date :',
	profileReq_id: 'Id :',

	//=======================tradingtools================================
	//==============autochartist scanner
	autoscan_AutochartistScanner: 'AutoChartist Scanner',
	autoscan_IBintegrateAdvancedTool: 'AutoChartist is a premier chart pattern recognition software that scans trading instruments and automatically recognizes trade set-ups based on breakouts, retracements, support and resistance levels so that you never miss an opportunity again.',
	autoscan_closeMt4: 'Log In to your fxview MT4 account.',
	autoscan_DownloadRunAuto: 'Download and run AutoChartist Scanner application.',
	autoscan_SelectPortfoliosTrading: 'Select fxview MT4 Platform and proceed with the installation.',
	autoscan_RestartMt4Platform: 'Restart fxview MT4 platform.',
	autoscan_autochartistdesc: 'Autochartist Scanner can be used on the live MT4 account with a minimum deposit amount of $200.',
	autoscan_DisclaimerAutoChartist: 'Disclaimer : The posts on this page are considered marketing communication and do not contain, and should not be construed as containing, investment advice or an investment recommendation or, an offer of or solicitation for any transactions in financial instruments. Past performance is not indicative of future results. Seek independent advice if necessary.',

	//==============autochartist.vue
	autochar_autocharist: 'Auto Chartist ',
	autochar_CreateLiveAccount: 'Create Live Account',
	autochar_Cancel: 'Cancel',



	//===================subscription verify=====================
	subVerf_reqVerify: 'Request Verification',
	subVerf_dear: 'Dear',
	subVerf_your: 'your',
	subVerf_accountVerMsz1: 'request has been processed successfully',
	subVerf_backSubList: 'Back to susbcription tools',

	//==========subsTransaction detail=================
	subtrans_heading: 'Subscription Transaction Detail',
	subtrans_date: 'Date (created)',
	subtrans_payType: 'Pay Type',
	subtrans_planprice: 'Plan Price',
	subtrans_coupon: 'Coupon',
	subtrans_amount: 'Amount',
	subtrans_noData: 'no data',
	subtrans_backVPSlist: 'back to VPS list',

	//================vps detail
	vpsdetail_heading: 'VPS Detail',
	vpsdetail_IPAddress: 'IP Address',
	vpsdetail_ServerId: 'Server Id',
	vpsdetail_HostName: 'Host Name',
	vpsdetail_Disk: 'Disk',
	vpsdetail_Cpu: 'Cpu',
	vpsdetail_Memory: 'Memory',
	vpsdetail_State: 'State',
	vpsdetail_Created: 'Date',
	vpsdetail_action: 'Action',

	//============trading tool box
	toolbox_tradeToolbox: 'Trader’s Tool Box',
	toolbox_moreAboutTradeToolbox: 'Find more about Trader’s Tool Box',
	toolbox_tradeToolMsz1: 'Enrich your trading with fxview Trader’s Tool Box - a suite of robust indicators and applications that adds convenience to your trading journey.',
	toolbox_WhatYouGet: 'What you get',
	toolbox_TraderToolboxApp: 'Trader’s Tool Box Application',
	toolbox_TradeTerminal: 'Trade Terminal',
	toolbox_MiniTerminal: 'Mini Terminal',
	toolbox_AlarmsManager: 'Alarms Manager',
	toolbox_ExcelRTD: 'Excel RTD',
	toolbox_Connect: 'Connect',
	toolbox_SentimentTrader: 'Sentiment Trader',
	toolbox_SessionMap: 'Session Map',
	toolbox_MarketManager: 'Market Manager',
	toolbox_CorrelationMatrix: 'Correlation Matrix',
	toolbox_CorrelationTrader: 'Correlation Trader',
	toolbox_TickTrader: 'Tick Trader',
	toolbox_StealthOrder: 'Stealth order',
	toolbox_IndicatorPackage: 'Indicator Package',
	toolbox_Minichart: 'Mini chart',
	toolbox_PivotPoints: 'Pivot Points',
	toolbox_HighsLows: 'Highs and Lows',
	toolbox_Renkobars: 'Renko bars',
	toolbox_ChartGroup: 'Chart Group',
	toolbox_SymbolInfo: 'Symbol Info',
	toolbox_Gravity: 'Gravity',
	toolbox_Chart_in_Chart: 'Chart-in-Chart',
	toolbox_PeriodConverter: 'Period Converter',
	toolbox_Magnifier: 'Magnifier',
	toolbox_OrderHistory: 'Order History',
	toolbox_FreehandDrawing: 'Freehand Drawing',
	toolbox_BarChanger: 'Bar Changer',
	toolbox_KeltnerChannel: 'Keltner Channel',
	toolbox_DonchianChannel: 'Donchian Channel',
	toolbox_CandleCountdown: 'Candle Countdown',
	toolbox_LinearRegression: 'Linear Regression',
	toolbox_howtoinstall: "HOW TO INSTALL TRADER'S TOOL BOX",
	toolbox_loginFxViewmt45: 'Log In to your fxview MT5 account',
	toolbox_ToolboxApplication: 'Download and run MT5 Trader’s Tool Box application',
	toolbox_FxviewMT45installation: 'Select fxview MT5 Platform and proceed with the installation',
	toolbox_allowDdlImports: 'Click on tools> options> expert advisor> and then click ok to allow DDL imports',
	toolbox_RestartFxviewMT45: 'Restart fxview MT5 platform',
	toolbox_tradeToolboxliveMinDeposit: "The Trader's Tool Box application can be used on the live MT5 account with a minimum deposit amount of $500.",
	toolbox_DisclaimerAutoChartist: 'Disclaimer : The posts on this page are considered marketing communication and do not contain, and should not be construed as containing, investment advice or an investment recommendation or, an offer of or solicitation for any transactions in financial instruments. Past performance is not indicative of future results. Seek independent advice if necessary.',

	//=====================subscription service plan
	subscription_Subscriptionheading: 'Subscriptions',
	subscription_SubMsz: 'Take your desired plan to get access to our content easily, we like to offer special license offer to our users.',
	subscription_mnth: '/Month',
	subscription_freeMin: 'FREE - MIN',
	subscription_deposit: 'Deposits',
	subscription_Features: 'Features',
	subscription_window: 'window',
	subscription_Memory: 'Memory',
	subscription_ssdDisk: 'SSD DISK',
	subscription_create: 'Create',
	//===================createSub ticket

	subticket_getSubPlan: 'Get Subscription For this Plan',
	subticket_applyCouponCode: 'Applied coupon code :',
	subticket_TotalAmount: 'Total Amount',
	subticket_havePromoCode: 'Have a Promocode?',
	subticket_deducedMonthlySubscription: 'Please select the trading ID from where you want the cost to be deduced for monthly subscription in case minimum conditions aren’t met for free VPS.',
	subticket_demo: 'Demo',
	subticket_live: 'Live',
	subticket_noteUnsubTool: 'Note: Payment will be only deducted once you click on the subscribe',
	subticket_clickToAgree: 'Click Here to agree',
	subticket_vpsTC: 'VPS T&C.',
	subticket_linkToSub: 'Kindly click on that link to subscribe.',
	subticket_subsucce: 'has been Subscribed Successfully. To know more detail, click on the below button',
	subticket_AutoChartPage: 'Go to Auto Chartist Page',
	subticket_controlsignalPage: 'Go to Control Signal Page',
	subticket_researchReportpage: 'Go to Research Reports Page',
	subticket_currentNewsPage: 'Go to Current News Page',
	subticket_economicCalPage: 'Go to Economic Calender Page',
	subticket_vpsPage: 'Go to VPS Page',
	subticket_selectPromoCode: 'Select a Promo Code ',
	subticket_EnterCouponCode: 'Enter Coupon Code',
	subticket_Apply: 'Apply',
	subticket_For: 'For',
	subticket_noPromoCode: "You don't Have any Promocode Yet!",
	subticket_vpsSubPlan: 'VPS PLAN SUBSCRIPTION',
	subticket_createVPS: 'Please add funds to create VPS',
	subticket_goDepositPage: 'Go to deposit Page',


	//action file language

	//=============================messages================================================
	noTradingCreateNewOne: 'No Trading Account Yet, Create a New Account',
	faMszOtp1: 'or use can also use 2fa OTP but you should enable first by click on the link given below',
	RESEND_EMAIL: 'Resend Email',
	TECH_ERROR: "We are facing some issues , Kindly try after some time",
	VALIDATION_ERROR: 'validation error',
	INVALID_TRADING_ACC: 'invalid trading account error',
	INVALID_WITHDRAWAL_TRANSACTION: 'invalid withdrawal transaction',
	INVALID_OTP: 'invalid OTP',
	FILE_UPLOAD: 'Only jpg, jpeg, png, pdf files are allowed!',
	OTP_EXPIRED: 'OTP expired',
	OTP_IP_MISMATCH: 'OTP is not match',
	LOW_BALANCE_THEN_AMOUNT: 'The amount that you have entered is higher than the Free Margin available.',
	TICKET_EXIST: 'ticket already exists',
	EMAIL_EXIST: 'email is already exists',
	MOBILE_EXIST: 'mobile number is already exists',
	LOW_BONUS_THEN_AMOUNT: 'amount that you have filled is low then your bonus',
	INVALID_ACCOUNT_TRANSACTION: 'invalid account transaction',
	INVALID_TICKET_TRANSACTION: 'invalid ticket transaction',
	DEPOSIT_LIMIT: 'deposit limit',
	AMOUNT_GREATER_THEN_ALLOWED: 'The amount that you have entered is higher then the allowed.',
	fund_msz: 'deposit successfully',
	suceessMsz1: '2FA Enabled successfully',
	suceessMsz2: '2FA Disabled successfully',
	suceessMsz3: 'A link for change password has been sent on your registered email id',
	suceessMsz4: 'Password changed successfully',
	suceessMsz5: 'OTP resend successfully',
	suceessMsz6: 'OTP is sent on your register email and mobile number',
	suceessMsz7: 'Now you are eligible to open live account',
	suceessMsz8: 'please upload your document within 15 days',
	suceessMsz9: "add name successfully",
	suceessMsz10: 'link has been sent your registered email id',
	suceessMsz11: 'plan unsubscribe successfully',
	suceessMsz12: 'service restart successfully',
	suceessMsz13: 'service reboot successfully',
	suceessMsz14: 'service shutdown successfully',
	suceessMsz15: 'service password changed successfully',
	suceessMsz16: 'A link has been sent to your registered email address',
	suceessMsz17: 'deposit successfully',
	suceessMsz18: 'OTP resend successfully',
	suceessMsz19: 'add bank successfully',
	suceessMsz20: 'ticket has been created successfully and please wait for 2-3 working days',
	suceessMsz21: 'At this moment we are allowing 1,00,000,00 only. In case you want to deposit more than this kindly contact support',
	suceessMsz22: 'you are not allowed to enter amount greater then or equal to deposit limit - , because you are not verified yet and ur document is still under verification so you cannot deposit more then2000 EUR',
	suceessMsz23: 'Invalid Amount',
	suceessMsz24: 'Your account is not verified',
	suceessMsz25: 'account id should be different from another account id you selected	',
	suceessMsz26: 'atleast select 2 options',
	suceessMsz27: 'new password is not same as confirm new password',
	suceessMsz28: 'Your password must contain at least 6 characters, and include at least 1 number, 1 uppercase character and 1 special character (!@#$%^&*/)',
	suceessMsz29: '',
	errorMsz1: "Sorry! This link has been exipred. Click <router-link :to='/forgot-password'>Here</router-link> to reset again!",
}


// WEBPACK FOOTER //
// ./src/plugins/lang/languages/en.js